"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankBranchT = exports.LeaveInclusionT = exports.AwardAllowanceT = exports.EmployeeT = exports.EmployeePayrollRecordT = exports.PersSuperT = exports.OccSuperT = exports.TimeRangeT = exports.PublicHolTypeT = exports.ReportStructureExportTypesT = exports.ReportStructureParamsT = exports.ReportStructureParamT = exports.ReportJobPayrollT = exports.ReportJobReportT = exports.ReportsParamT = exports.ParamValueT = exports.CacheT = exports.ShiftTypePayAllowT = exports.PublicHolidayT = exports.RosterAreaT = exports.StaticHashT = exports.ClassAllowanceT = exports.AllowFrequencyT = exports.PersonT = exports.ReadOnlyT = exports.AgencyT = exports.DeductTypeBankingT = exports.DeductBankingT = exports.PersonalSuperTypeT = exports.ShiftWorkerT = exports.BankSplitTypeT = exports.EmplTaxOptionT = exports.STPEventT = exports.FacilityT = exports.ClearingHouseT = exports.ABNT = exports.CompanyT = exports.SuperFundT = exports.SuperPlanT = exports.CostCentres3LevelT = exports.JournalAccountT = exports.CostCentreT = exports.LocationT = exports.PayrollDeductionT = exports.DeductGroupT = exports.PayrollAllowanceT = exports.AwardT = exports.PayrollClassificationT = exports.PeriodT = exports.tTimeT = void 0;
exports.JobLeaveShiftsT = exports.JobLeaveDayShiftsT = exports.JobLeaveDayShiftT = exports.JobLeaveAllowancesT = exports.JobLeaveAllowanceT = exports.JobPrevExpT = exports.JobDomViolenceLeaveT = exports.JobSickLeaveT = exports.JobCostCentresT = exports.JobCostCentreT = exports.JobLSLExclDaysT = exports.JobLSLT = exports.JobPenaltiesT = exports.JobAddLeaveShiftCountsT = exports.JobAnnualLeaveT = exports.JobLeaveAccrualT = exports.TimeRelationT = exports.BasicWageT = exports.LslAccrualMethodT = exports.LoadingPaidTypeT = exports.DeathPayTypeT = exports.ShiftTypeT = exports.LeaveCategoryT = exports.LoadingCalcTypeT = exports.JobAllowActionT = exports.TermTypeT = exports.AmountTypeT = exports.SuperLeaveReasonT = exports.SuperPayTypeT = exports.WorkTypeT = exports.PayTypeT = exports.PayMethodT = exports.SexT = exports.StatesT = exports.PostCodeT = exports.SalutationT = exports.TaxWeeksDefaultT = exports.ExtraTaxOptionT = exports.TaxCodeT = exports.TaxExemptionT = exports.BanksListT = exports.BankT = exports.ABAFrequencyT = exports.SysValuesT = exports.PayrollRateT = exports.JobSplitT = exports.DeductEmployeeT = exports.LeaveDefinedAllowanceT = exports.PayrollAllowCriteriaT = exports.BankEmplT = void 0;
exports.CountryT = exports.IncrementGroupT = exports.IncrementingT = exports.UsedClassificationsT = exports.RosterAccessTypesT = exports.SuperSMSFT = exports.SuperBankT = exports.TimesheetExtrasChangesT = exports.ReportT = exports.LoadedDataT = exports.EOYFBDeductionT = exports.ReportParamsT = exports.TimesheetT = exports.TimesheetDetailsT = exports.LumpET = exports.TimesheetDayShiftsT = exports.TimesheetShiftT = exports.TimesheetPayrunAllowanceT = exports.TimesheetShiftAllowanceT = exports.TimesheetDeductionsT = exports.TimesheetDeductionT = exports.JobAllowancesT = exports.JobAllowanceT = exports.PayrollRecordT = exports.PayrollRecordsT = exports.PayrollRecordsListT = exports.PayrollRecordListItemT = exports.PayrollRecordDetailsT = exports.PayrollRecordJobTotalT = exports.PayrollRecordJobT = exports.PayrollRecordLumpEsT = exports.PayrollRecordLumpET = exports.PayrollRecordTermLeaveT = exports.PayrollRecordCostSplitT = exports.PayrollRecordLeaveT = exports.PayrollRecordAllowanceT = exports.PayrollRecordPubHolT = exports.PayrollRecordPayRateT = exports.PayrollRecordPaymentT = exports.PayrollRecordDeductionT = exports.PayrollRecordPersSuperT = exports.PayrollJobT = exports.JobDetailsT = exports.LinkedJobsT = exports.JobLeaveHistoriesT = exports.JobLeaveHistoryT = exports.SelectableAllowancesT = exports.SelectableAllowanceT = exports.JobLeaveGridRowT = exports.JobAllowanceRecordT = void 0;
exports.FileLockerFolderT = exports.ErrorsListT = exports.ErrorItemT = exports.PayrollErrorT = exports.EmployeeOnBoardT = exports.TFNsT = exports.TFNT = exports.EmplCompT = exports.ExpCalcMethodsT = exports.PayrollRatesT = exports.PayrollPayRatesT = exports.ReportParamT = exports.DeductionExtraT = exports.AllowanceExtrasT = exports.AllowanceExtraT = exports.STPStateT = exports.STPActionT = exports.STPEmplT = exports.STPApprovalStateT = exports.STPHistoryT = exports.TaxRateT = exports.PayrollSTPEventT = exports.TaxRateGeneralT = exports.EOYFBAdjT = exports.TransferTypeT = exports.TransferFormatT = exports.ATOTransferT = exports.ABADefinitionT = exports.CHFormatT = exports.CompanyBankT = exports.CalcShiftRateT = exports.PayrollShiftAllowanceT = exports.SeqShiftT = exports.AddShiftWkTypeT = exports.AddSeqT = exports.LSLSeqT = exports.SLSeqT = exports.SickMethodT = exports.LoadingAveMethodT = exports.AwardHolRateT = exports.ShiftInclusionT = exports.PayrollShiftT = exports.LoadCheckT = exports.GCDeductionsT = exports.AllowCriteriaSeqT = exports.AllowCriteriaSeqItemT = exports.CTaxExemptionsT = exports.CTaxCodesT = exports.NameValStrT = exports.NameValNumT = void 0;
exports.ValidationWarningsT = exports.ValidationErrorsT = exports.OzediFundResponseXMLT = exports.OzediPaymentsFileT = exports.OzediUploadFileErrorsT = exports.OzediMessageResponseT = exports.OzediSuperNewMemberDataT = exports.OzediSuperMemberDataT = exports.OzediEmplSuperRecordT = exports.GeneratorTypesT = exports.CompanyTransferProgressResponseT = exports.PayrollUpgradeProgressResponseT = exports.PayrollRosterImporterProgressT = exports.JobTermTotalT = exports.STPxmlDataT = exports.STPXmlSubmissionDataT = exports.STPSubmissionStatusT = exports.TPEResultT = exports.TPEErrorT = exports.UnloadedDataT = exports.DataModelPayrollT = exports.StaticDataTypeT = exports.ConstantsT = exports.SMSFAliasT = exports.SuperUploadActionT = exports.SuperUploadDataT = exports.OccSuperUnprocessedT = exports.PayToAgreementT = exports.SuperValidationDataT = exports.PayrollManualT = exports.RunYearTotalsT = exports.RunTotalsT = exports.RunTotalT = exports.WindowDefaultT = void 0;
const t = __importStar(require("@sinclair/typebox"));
const meta_types_1 = require("./meta-types");
const types_reports_1 = require("./types-reports");
exports.tTimeT = t.String({ format: 'time' });
exports.PeriodT = t.Object({
    ID: t.Number(),
    PayRun: t.Number(),
    StartDate: meta_types_1.tDateT,
    Year: t.Number(),
    Month: t.Number(),
    State: t.Number(),
    EndDate: meta_types_1.tDateT,
    ABAReleaseDt: meta_types_1.tDateT,
    STPReleaseDt: meta_types_1.tDateT,
});
exports.PayrollClassificationT = t.Object({
    ID: t.Number(),
    Name: t.String(),
    PrefName: (0, meta_types_1.MaybeT)(t.String()),
    Code: t.String(),
    Award: t.Number(),
    RosterAccess: t.Number(),
    YearsExp: t.Number(),
    DefaultCC: t.Number(),
    IncMethod: t.Number(),
    AveragingLength: (0, meta_types_1.MaybeT)(t.String()),
    ResetAtEnd: t.Boolean(),
    Inactive: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    NewClassification: t.Boolean(),
});
exports.AwardT = t.Object({
    ID: t.Number(),
    Name: t.String(),
    StateVersion: t.String(),
    Description: t.String(),
    CasLoading: t.String(),
    LoadAnnLve: t.Number(),
    NoLoadAnnLve: t.Number(),
    FTHrsPerWeek: t.String(),
    LSLAccMethod: t.String(),
    MealLength: t.String(),
    HoursForMeal: t.String(),
    HrsPerADO: t.String(),
    BSAMaxHr: t.String(),
    MaxBSBreak: t.String(),
    MaxBSLength: t.String(),
    InclTravelBS: t.Boolean(),
    InclTrainingBS: t.Boolean(),
    GapLengthGuide: t.String(),
    MinBOWLength: t.String(),
    LSLAveWeeks: t.Number(),
    ALLoadPercent: t.String(),
    ADOPercent: t.String(),
    PayADOAdjustment: t.Boolean(),
    PayAdjInclAward: t.Boolean(),
    PayAdjInclGuar: t.Boolean(),
    PubHolsPerYear: (0, meta_types_1.MaybeT)(t.Number()),
    SuperDollThreshold: (0, meta_types_1.MaybeT)(t.String()),
    SuperHourThreshold: (0, meta_types_1.MaybeT)(t.String()),
    MaxPaidTaskGapTime: t.Number(),
    LoadingAveMethod: t.String(),
    PenaltyAveLength: t.Number(),
    CasSuperReview: t.Boolean(),
    SickAccrueMethod: t.String(),
    AddSat: t.Boolean(),
    AddSun: t.Boolean(),
    AddWeekend: t.Boolean(),
    AddPH: t.Boolean(),
    MinAddSat: t.Number(),
    MinAddSun: t.Number(),
    MinAddWeekend: t.Number(),
    MinAddPH: t.Number(),
    MinSatHrs: t.String(),
    MinSunHrs: t.String(),
    MinWeekendHrs: t.String(),
    MinPHHrs: t.String(),
    CTLSuperInclude: t.Boolean(),
    LSLEligableYrs: t.Number(),
    DateInactive: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    MaxExtraLeave: t.String(),
    MaxADOHrs: t.String(),
    MaxSickAccrued: t.String(),
    Active: t.Boolean(),
    LveLoadInclSuper: t.Boolean(),
});
exports.PayrollAllowanceT = t.Object({
    ID: t.Number(),
    Name: t.String(),
    Frequency: t.Number(),
    Taxable: t.Boolean(),
    SuperInclude: t.Boolean(),
    PrintGC: t.Boolean(),
    Rostered: t.Boolean(),
    Editable: t.Boolean(),
    RosterTravel: t.Boolean(),
    ServiceTravel: t.Boolean(),
    RosterReimbursement: t.Boolean(),
    BSGap: t.Boolean(),
    PTExempt: t.Boolean(),
    JKFlag: t.Number(),
    ATOCode: (0, meta_types_1.MaybeT)(t.String()),
    ODCat: (0, meta_types_1.MaybeT)(t.String()),
    OTime: t.Boolean(),
    Bonus: t.Boolean(),
    DrFees: t.Boolean(),
    Reimburse: t.Boolean(),
    FullyExpended: t.Boolean(),
    Deductable: t.Boolean(),
    DateInactive: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    FYUsed: t.Optional(t.Boolean()),
    IsNew: t.Optional(t.Boolean()),
});
exports.DeductGroupT = t.Object({
    ID: t.Number(),
    Name: t.String(),
    PostTax: t.Number(),
    ATOCode: (0, meta_types_1.MaybeT)(t.String()),
    GCDeduction: (0, meta_types_1.MaybeT)(t.Number()),
    PGMCode: (0, meta_types_1.MaybeT)(t.String()),
    FYUsed: t.Optional(t.Boolean()),
    IsNew: t.Optional(t.Boolean()),
});
exports.PayrollDeductionT = t.Object({
    ID: t.Number(),
    DeductGroup: t.Number(),
    Name: t.String(),
    InclAllowances: t.Boolean(),
    Order: t.Number(),
    MinRemaining: t.String(),
    Inactive: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    OldDGKey: (0, meta_types_1.MaybeT)(t.Number()),
    TypeRate: t.Number(),
});
exports.LocationT = t.Object({
    ID: t.Number(),
    Name: t.String(),
});
exports.CostCentreT = t.Object({
    ID: t.Number(),
    Name: t.String(),
    ParentCC: (0, meta_types_1.MaybeT)(t.Number()),
    Used: t.Boolean(),
});
exports.JournalAccountT = t.Object({
    JournalAccountKey: t.Number(),
    CompanyKey: (0, meta_types_1.MaybeT)(t.Number()),
    CostKey: (0, meta_types_1.MaybeT)(t.Number()),
    TopLevelCostKey: (0, meta_types_1.MaybeT)(t.Number()),
    SourceKey: (0, meta_types_1.MaybeT)(t.Number()),
    Name: (0, meta_types_1.MaybeT)(t.String()),
    Credit: (0, meta_types_1.MaybeT)(t.Number()),
    Account: (0, meta_types_1.MaybeT)(t.String()),
    Description: (0, meta_types_1.MaybeT)(t.String()),
    Job: (0, meta_types_1.MaybeT)(t.String()),
    ItemType: (0, meta_types_1.MaybeT)(t.String()),
});
exports.CostCentres3LevelT = t.Object({
    ID: t.Number(),
    Name1: t.String(),
    ID2: t.Number(),
    Name2: t.String(),
    ID3: t.Number(),
    Name3: t.String(),
    Name: t.String(),
});
exports.SuperPlanT = t.Object({
    ID: t.Number(),
    Name: t.String(),
    PlanPercent: t.String(),
    SuperFund: t.Number(),
    PersonalSuper: t.Boolean(),
    MinHrsPerWeek: (0, meta_types_1.MaybeT)(t.String()),
    MinContribution: t.String(),
    NewFund: t.Boolean(),
    FundID: (0, meta_types_1.MaybeT)(t.String()),
    FVSKey: t.Number(),
    DateInactive: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    IsActive: t.Boolean(),
});
exports.SuperFundT = t.Object({
    ID: t.Number(),
    Name: t.String(),
    Address: t.String(),
    City: t.String(),
    State: t.String(),
    PostCode: (0, meta_types_1.MaybeT)(t.Number()),
    Contact: (0, meta_types_1.MaybeT)(t.String()),
    Phone: (0, meta_types_1.MaybeT)(t.String()),
    Fax: (0, meta_types_1.MaybeT)(t.String()),
    EmployerNumber: (0, meta_types_1.MaybeT)(t.String()),
    MinEarn: t.String(),
    ApplyMaxCap: t.Boolean(),
    ReduceSuperSac: t.Boolean(),
    ReduceSalPack: t.Boolean(),
    FundID: (0, meta_types_1.MaybeT)(t.String()),
    TransferGross: t.Boolean(),
    Default: t.Boolean(),
    SMSF: t.Boolean(),
    DateInactive: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    IsActive: t.Boolean(),
});
exports.CompanyT = t.Object({
    ID: t.Number(),
    CompanyCode: t.String(),
    Name: t.String(),
    MainCo: t.Boolean(),
    LegalEntity: t.Number(),
    Address: t.String(),
    City: t.String(),
    State: t.String(),
    PostCode: t.Number(),
    Contact: (0, meta_types_1.MaybeT)(t.String()),
    Phone: (0, meta_types_1.MaybeT)(t.String()),
    Fax: (0, meta_types_1.MaybeT)(t.String()),
    Email: (0, meta_types_1.MaybeT)(t.String()),
    Beds: (0, meta_types_1.MaybeT)(t.Number()),
    BankBSB: (0, meta_types_1.MaybeT)(t.String()),
    BankAccount: (0, meta_types_1.MaybeT)(t.String()),
    SuperCH: (0, meta_types_1.MaybeT)(t.Number()),
    DateInactive: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    Bank: t.String(),
});
exports.ABNT = t.Object({
    ID: t.Number(),
    EntityName: t.String(),
    ABN: t.String(),
    BranchCode: t.Number(),
    OzEDIClientID: t.String(),
    FBTExempt: t.Boolean(),
    Signer: t.String(),
    ETPPayerType: (0, meta_types_1.MaybeT)(t.String()),
    SIBMSID: t.String(),
    DeclContractor: t.Boolean(),
    WHMRegistered: t.Boolean(),
    SSID: t.String(),
});
exports.ClearingHouseT = t.Object({
    ID: t.Number(),
    EmployerID: (0, meta_types_1.MaybeT)(t.String()),
    Name: t.String(),
    FileName: t.String(),
});
exports.FacilityT = t.Object({
    ID: t.Number(),
    Name: t.String(),
    PTExempt: t.Boolean(),
});
exports.STPEventT = t.Object({
    ID: t.Number(),
    PayPeriod: t.Number(),
    ABN: t.String(),
    Timestamp: t.String(),
});
exports.EmplTaxOptionT = t.Object({
    ID: t.String(),
    TaxOption: t.Number(),
    Employee: t.Number(),
});
exports.BankSplitTypeT = t.Object({
    BankSplitType: t.String(),
    TypeName: t.String(),
    EvaluationOrder: t.Number(),
});
exports.ShiftWorkerT = t.Object({
    ID: t.Number(),
    Name: t.String(),
});
exports.PersonalSuperTypeT = t.Object({
    ID: t.Number(),
    Name: t.String(),
    PostTax: t.Boolean(),
    PostAllowances: t.Boolean(),
});
exports.DeductBankingT = t.Object({
    DeductEmployee: t.Number(),
    BSB: (0, meta_types_1.MaybeT)(t.String()),
    Account: (0, meta_types_1.MaybeT)(t.String()),
    AccountName: t.String(),
    Reference: (0, meta_types_1.MaybeT)(t.String()),
    Frequency: t.Number(),
});
exports.DeductTypeBankingT = t.Object({
    ID: t.Number(),
    BSB: (0, meta_types_1.MaybeT)(t.String()),
    Account: (0, meta_types_1.MaybeT)(t.String()),
    AccountName: (0, meta_types_1.MaybeT)(t.String()),
    Reference: (0, meta_types_1.MaybeT)(t.String()),
    Frequency: (0, meta_types_1.MaybeT)(t.Number()),
});
exports.AgencyT = t.Object({
    ID: t.Number(),
    Name: t.String(),
});
exports.ReadOnlyT = t.Object({
    readOnly: t.Boolean(),
    error: (0, meta_types_1.MaybeT)(t.String()),
});
exports.PersonT = t.Object({
    ID: t.Number(),
    Description: t.String(),
});
exports.AllowFrequencyT = t.Object({
    ID: t.Number(),
    Code: t.String(),
    Name: t.String(),
    RequireEdit: t.Boolean(),
    ForShifts: t.Boolean(),
    ForAwards: t.Boolean(),
    ForJobs: t.Boolean(),
    ShiftLevel: t.Boolean(),
});
exports.ClassAllowanceT = t.Object({
    Criteria: t.Number(),
    Classification: t.Number(),
});
exports.StaticHashT = t.Object({
    lastVersionTS: meta_types_1.tDatetimeT,
    banksListCount: t.Number(),
});
exports.RosterAreaT = t.Object({
    ID: t.Number(),
    Facility: t.Number(),
    Area: t.Number(),
    Name: t.String(),
    CostCentre: (0, meta_types_1.MaybeT)(t.Number()),
});
exports.PublicHolidayT = t.Object({
    ID: t.Number(),
    Name: t.String(),
    LastYear: t.String(),
    CurrentYear: t.String(),
    NextYear: (0, meta_types_1.MaybeT)(t.String()),
    Start: (0, meta_types_1.MaybeT)(exports.tTimeT),
    Finish: (0, meta_types_1.MaybeT)(exports.tTimeT),
    FixedDate: t.Boolean(),
    HolType: (0, meta_types_1.MaybeT)(t.String()),
    ReadOnly: t.Boolean(),
    Inactive: (0, meta_types_1.MaybeT)(t.String()),
});
exports.ShiftTypePayAllowT = t.Object({
    ID: t.String(),
    ShiftType: t.Number(),
    Criteria: t.Number(),
});
exports.CacheT = t.Object({
    suffix: t.String(),
    key: t.String(),
    u: t.String(),
});
exports.ParamValueT = t.Union([
    t.String(),
    t.Array(t.String()),
    t.Array(t.Number()),
    t.Boolean(),
    t.Literal('0'),
    t.Literal('1'),
]);
exports.ReportsParamT = t.Object({
    ID: t.Number(),
    Report: t.String(),
    Name: t.String(),
    Value: exports.ParamValueT,
});
exports.ReportJobReportT = t.Object({
    ID: t.Number(),
    ReportJob: t.Number(),
    Type: t.String(),
    Name: t.String(),
    ExportType: types_reports_1.ReportExportTypeT,
    Params: t.Record(t.String(), exports.ParamValueT),
    OverriddenParams: t.Array(t.String()),
});
exports.ReportJobPayrollT = t.Object({
    ID: t.Number(),
    Name: t.String(),
    Hidden: meta_types_1.tBoolT,
    Created: meta_types_1.tDatetimeT,
    BaseParams: t.Record(t.String(), exports.ParamValueT),
    Reports: (0, meta_types_1.ModelTypeT)(exports.ReportJobReportT),
});
exports.ReportStructureParamT = t.Object({
    Key: t.String(),
    Label: t.String(),
    Type: t.String(),
    Nullable: t.Boolean(),
    Default: exports.ParamValueT,
});
exports.ReportStructureParamsT = t.Array(exports.ReportStructureParamT);
exports.ReportStructureExportTypesT = t.Array(types_reports_1.ReportExportTypeT);
exports.PublicHolTypeT = t.Object({
    Code: t.String(),
    Name: t.String(),
    Selectable: t.Boolean(),
    Override: t.Boolean(),
    Inactive: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
});
exports.TimeRangeT = t.Object({
    ID: t.Number(),
    Name: t.String(),
    FromRelation: (0, meta_types_1.MaybeT)(t.Number()),
    FromTime: (0, meta_types_1.MaybeT)(exports.tTimeT),
    Joiner: (0, meta_types_1.MaybeT)(t.Number()),
    ToRelation: (0, meta_types_1.MaybeT)(t.Number()),
    ToTime: (0, meta_types_1.MaybeT)(exports.tTimeT),
});
exports.OccSuperT = t.Object({
    ID: (0, meta_types_1.MaybeT)(t.String()),
    Employee: t.Number(),
    Plan: t.Number(),
    Joined: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    Left: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    NegRate: t.String(),
    LeaveReason: (0, meta_types_1.MaybeT)(t.Number()),
    MemberNumber: t.String(),
    FirstUsed: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    LastUsed: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    Verified: t.Boolean(),
});
exports.PersSuperT = t.Object({
    ID: t.String(),
    EmployeeCode: t.Number(),
    Plan: t.Number(),
    Type: t.Number(),
    Joined: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    Left: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    Amount: t.String(),
    AmountType: t.Number(),
    MemberNumber: t.String(),
    FirstUsed: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    LastUsed: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
});
exports.EmployeePayrollRecordT = t.Object({
    ID: t.Number(),
    Deductions: t.Number(),
    Gross: t.Number(),
    Net: t.Number(),
    Tax: t.Number(),
    JobsWorked: t.String(),
    PayPeriod: t.Number(),
    PayrunJob: t.Number(),
    ScheduledDate: meta_types_1.tDateT,
});
exports.EmployeeT = t.Object({
    ID: t.Number(),
    Title: (0, meta_types_1.MaybeT)(t.String()),
    Surname: t.String(),
    FGiven: t.String(),
    SGiven: (0, meta_types_1.MaybeT)(t.String()),
    PrefName: t.String(),
    StreetAddress: t.String(),
    City: t.String(),
    State: t.String(),
    PostCode: (0, meta_types_1.MaybeT)(t.Number()),
    PhoneNo: (0, meta_types_1.MaybeT)(t.String()),
    MobileNo: (0, meta_types_1.MaybeT)(t.String()),
    Email: (0, meta_types_1.MaybeT)(t.String()),
    EmailPayslips: t.Boolean(),
    Sex: t.String(),
    BirthDate: meta_types_1.tDateT,
    CommDate: meta_types_1.tDateT,
    EndDate: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    TaxCode: t.String(),
    TFNExempt: (0, meta_types_1.MaybeT)(t.String()),
    TFNDisc: t.Boolean(),
    PayTax: t.Boolean(),
    TaxRebate: t.String(),
    RegNo: (0, meta_types_1.MaybeT)(t.String()),
    NurseRegoExp: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    SuperPay: t.String(),
    GroupCertDate: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    D_GC_CDEP: t.String(),
    PayMethod: t.String(),
    SalPackTotLastFY: t.Number(),
    SalPackLastFY: t.Number(),
    AgencyKey: (0, meta_types_1.MaybeT)(t.Number()),
    ReplacementEmpl: (0, meta_types_1.MaybeT)(t.Number()),
    TaxWeeksDefault: t.String(),
    FlatTaxRate: (0, meta_types_1.MaybeT)(t.String()),
    EmplALAnniv: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    NOK: (0, meta_types_1.MaybeT)(t.String()),
    NOKPhone: (0, meta_types_1.MaybeT)(t.String()),
    NOKRelation: (0, meta_types_1.MaybeT)(t.String()),
    Contact: (0, meta_types_1.MaybeT)(t.String()),
    ContactPhone: (0, meta_types_1.MaybeT)(t.String()),
    Notes: (0, meta_types_1.MaybeT)(t.String()),
    PoliceCheckRef: (0, meta_types_1.MaybeT)(t.String()),
    PoliceCheckDate: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    PoliceCheckConvictions: (0, meta_types_1.MaybeT)(t.Number()),
    DeclarationDate: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    PoliceExpiryDate: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    VisaCheckRef: (0, meta_types_1.MaybeT)(t.String()),
    VisaCheckDate: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    VisaCheckConvictions: (0, meta_types_1.MaybeT)(t.Number()),
    VisaStatDecl: t.Boolean(),
    VisaExpiryDate: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    ConductDate: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    TFNDeclDate: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    TFNDecl: t.Boolean(),
    ChildrenCheckDate: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    ChildrenExpiryDate: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    ChildrenCheckRef: (0, meta_types_1.MaybeT)(t.String()),
    FluVaccineDate: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    CovidVaccDate1: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    CovidVaccDate2: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    Person: (0, meta_types_1.MaybeT)(t.Number()),
    IsAgency: t.Boolean(),
    FullName: t.String(),
    FullAddress: t.String(),
    AllowGender: (0, meta_types_1.MaybeT)(t.String()),
    HomeCountry: (0, meta_types_1.MaybeT)(t.String()),
    MedSurcharge: t.String(),
    MedReductReason: t.String(),
    OccSuper: t.Optional((0, meta_types_1.MaybeT)(t.Record(t.Number(), exports.OccSuperT))),
    PersSuper: t.Optional((0, meta_types_1.MaybeT)(t.Record(t.Number(), exports.PersSuperT))),
    PayrollRecords: t.Optional(t.Record(t.Number(), exports.EmployeePayrollRecordT)),
    LastPaid: t.Optional(meta_types_1.tDateT),
});
exports.AwardAllowanceT = t.Object({
    Criteria: t.Number(),
    Award: t.Number(),
});
exports.LeaveInclusionT = t.Object({
    ID: t.String(),
    Award: t.Number(),
    Category: t.String(),
    AwardInclude: t.Boolean(),
    AwardUseBase: t.Boolean(),
    GuarInclude: t.Number(),
    GuarUseBase: t.Boolean(),
    ADOInclude: t.Boolean(),
    SLInclude: t.Boolean(),
    ALInclude: t.Boolean(),
    LSLInclude: t.Boolean(),
    SiteInclude: t.Boolean(),
});
exports.BankBranchT = t.Object({
    BankBSB: t.String(),
    Bank: t.Number(),
    BranchName: t.String(),
    Contact: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    PhoneNum: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    Fax: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    EMail: t.Optional((0, meta_types_1.MaybeT)(t.String())),
});
exports.BankEmplT = t.Object({
    ID: t.String(),
    EmployeeCode: t.Number(),
    BankBSB: (0, meta_types_1.MaybeT)(t.String()),
    AccNumUnformat: t.String(),
    BankAccount: t.String(),
    SplitType: t.String(),
    SplitAmount: (0, meta_types_1.MaybeT)(t.String()),
    SplitSeq: (0, meta_types_1.MaybeT)(t.Number()),
    AccountName: t.String(),
});
exports.PayrollAllowCriteriaT = t.Object({
    ID: t.Number(),
    Name: t.String(),
    AllowKey: t.Number(),
    Sex: (0, meta_types_1.MaybeT)(t.String()),
    Frequency: t.Number(),
    PermRate: t.String(),
    CasRate: t.String(),
    ApplyBaseRate: t.Boolean(),
    MinPerWk: t.String(),
    MaxPerWk: t.String(),
    MonToFri: t.Boolean(),
    Sat: t.Boolean(),
    Sun: t.Boolean(),
    PubHol: t.Boolean(),
    ByBed: t.Boolean(),
    ByEmpl: t.Boolean(),
    Automatic: t.Boolean(),
    MAEquivalent: (0, meta_types_1.MaybeT)(t.Number()),
    NewCriteria: t.Optional(t.Boolean()),
});
exports.LeaveDefinedAllowanceT = t.Object({
    Criteria: t.Number(),
    Category: t.String(),
});
exports.DeductEmployeeT = t.Object({
    ID: t.Number(),
    DeductType: t.Number(),
    Employee: t.Number(),
    StartDate: meta_types_1.tDateT,
    EndDate: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    Amount: t.Number(),
    AmountType: t.Number(),
    Reversing: t.Boolean(),
    Ignore: t.Boolean(),
});
exports.JobSplitT = t.Object({
    ID: t.String(),
    CostKey: t.Number(),
    Job: t.Number(),
    Split: t.Number(),
});
exports.PayrollRateT = t.Object({
    ID: (0, meta_types_1.MaybeT)(t.String()),
    ClassKey: t.Number(),
    PayPoint: t.Number(),
    Start: meta_types_1.tDateT,
    Value: t.String(),
});
exports.SysValuesT = t.Object({
    ABAPATH: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    ADOPERCENT: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    ALLOADPC: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    ARCHEMPL: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    AWARDSUPER: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    BACKUPPATH: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    BROKCLIENT: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    CODERED: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    CURRSTATE: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    CVTDATE: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    CVTDATESQL: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    DATADIR: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    DBVERSION: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    DEFFTWKHRS: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    DYNAMICPS: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    FYSLCERTS: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    IMPORTFXPH: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    JKON: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    LASTARCH: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    LSLAVEMAX: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    LSLAVEWKS: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    LSLAVG: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    MAXNOCERT: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    MAXSUPER: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    MINSUPER: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    MINSUPERHR: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    OCCSUPMAX: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    OCCSUPRATE: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    PAYDAY: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    PAYFREQ: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    PAYSPATH: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    PENAVELN: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    PERSONTEMP: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    PSEMAIL: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    PSPORT: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    RBAAC: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    RBAACNAME: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    RBABSB: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    REPORTHEAD: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    ROLLRUN: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    SHOUNACEMP: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    SHOWPHTBP: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    SLONFULDAY: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    STP2: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    SUCALCMETH: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    SUPERDOM: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    TAXWEEKS: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    PDSON: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    PDSQE: t.Optional((0, meta_types_1.MaybeT)(t.String())),
    SWTFIX: t.Optional((0, meta_types_1.MaybeT)(t.String())),
});
exports.ABAFrequencyT = t.Object({
    ID: t.Number(),
    Name: t.String(),
});
exports.BankT = t.Object({
    BankKey: t.Number(),
    BankName: t.String(),
    BankCode: t.String(),
});
exports.BanksListT = t.Object({
    BankBSB: t.String(),
    BankCode: t.String(),
    BranchName: t.String(),
});
exports.TaxExemptionT = t.Object({
    TaxExemption: t.String(),
    Description: t.String(),
});
exports.TaxCodeT = t.Object({
    TaxCode: t.String(),
    Description: t.String(),
    ResultRounding: t.Number(),
});
exports.ExtraTaxOptionT = t.Object({
    TaxOptionKey: t.Number(),
    TaxOptionName: t.String(),
    DateInactive: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
});
exports.TaxWeeksDefaultT = t.Object({
    TaxWeeksCode: t.String(),
    TaxWeeksDesc: t.String(),
});
exports.SalutationT = t.Object({
    Salutation: t.String(),
    Gender: t.String(),
});
exports.PostCodeT = t.Object({
    ID: t.String(),
    PostCode: t.Number(),
    Locality: t.String(),
    State: t.String(),
    DeliveryArea: t.Boolean(),
});
exports.StatesT = t.Object({
    StateCode: t.String(),
    StateName: t.String(),
});
exports.SexT = t.Object({
    SexCode: t.String(),
    SexName: t.String(),
});
exports.PayMethodT = t.Object({
    PayMethod: t.String(),
    Description: t.String(),
});
exports.PayTypeT = t.Object({
    ID: t.Number(),
    Name: t.String(),
});
exports.WorkTypeT = t.Object({
    WorkType: t.String(),
    Description: t.String(),
    SFCode: t.String(),
});
exports.SuperPayTypeT = t.Object({
    PayTypeCode: t.String(),
    Description: t.String(),
});
exports.SuperLeaveReasonT = t.Object({
    ID: t.Number(),
    Code: t.String(),
    Description: t.String(),
});
exports.AmountTypeT = t.Object({
    ID: t.Number(),
    Name: t.String(),
});
exports.TermTypeT = t.Object({
    ID: t.String(),
    Name: t.String(),
});
exports.JobAllowActionT = t.Object({
    ActionCode: t.String(),
    ActionName: t.String(),
});
exports.LoadingCalcTypeT = t.Object({
    ID: t.Number(),
    Name: t.String(),
});
exports.LeaveCategoryT = t.Object({
    Category: t.String(),
    Name: t.String(),
    Parent: (0, meta_types_1.MaybeT)(t.String()),
    Paid: t.Number(),
    Loading: t.Boolean(),
    TermLoading: t.Boolean(),
    Accrues: t.Boolean(),
    ExcludeYOS: t.Boolean(),
    DateInactive: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    PTExempt: t.Boolean(),
    weight: t.Number(),
});
exports.ShiftTypeT = t.Object({
    ID: t.Number(),
    Code: t.String(),
    Name: t.String(),
    Selectable: t.Boolean(),
    Searchable: t.Boolean(),
    DaySpecific: t.Boolean(),
    DateInactive: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
});
exports.DeathPayTypeT = t.Object({
    DeathPayType: t.String(),
    Description: t.String(),
});
exports.LoadingPaidTypeT = t.Object({
    ID: t.Number(),
    Name: t.String(),
});
exports.LslAccrualMethodT = t.Object({
    ID: t.String(),
    Name: t.String(),
});
exports.BasicWageT = t.Object({
    Start: meta_types_1.tDateT,
    Rate: t.String(),
});
exports.TimeRelationT = t.Object({
    ID: t.Number(),
    Code: t.String(),
    Name: t.String(),
});
exports.JobLeaveAccrualT = t.Object({
    LeaveName: t.String(),
    Accrued: t.String(),
    EmplAccrued: (0, meta_types_1.MaybeT)(t.String()),
    Category: t.String(),
});
exports.JobAnnualLeaveT = t.Record(t.String(), t.Object({
    Accrued: t.String(),
    ArchTaken: t.String(),
    Category: t.String(),
    PrevAccrued: t.String(),
    PrevArchTaken: t.String(),
}));
exports.JobAddLeaveShiftCountsT = t.Object({
    SatTotal: t.Number(),
    SunTotal: t.Number(),
    WETotal: t.Number(),
    PHTotal: t.Number(),
});
exports.JobPenaltiesT = t.Object({
    TotalHours: t.String(),
    TotalPenalties: t.String(),
    NumWeeks: t.Number(),
});
exports.JobLSLT = t.Record(t.String(), t.Object({
    Category: t.String(),
    AccruedHours: t.String(),
    AccruedWeeks: t.String(),
    TakenHours: t.String(),
    TakenWeeks: t.String(),
    LSLAveHrsPerWeek: t.String(),
}));
exports.JobLSLExclDaysT = t.Object({
    JobDays: t.Number(),
    JobsLSLHrsDays: t.Number(),
    PRLeaveDays: t.Number(),
    TotalDays: t.Number(),
});
exports.JobCostCentreT = t.Object({
    CostKey: t.Number(),
    PCSplit: t.String(),
    OrigKey: t.Number(),
});
exports.JobCostCentresT = t.Record(t.Number(), exports.JobCostCentreT);
exports.JobSickLeaveT = t.Object({
    CurrentNoCertSickDays: t.Number(),
    CalcDate: meta_types_1.tDateT,
});
exports.JobDomViolenceLeaveT = t.Record(t.Number(), t.Object({
    PayrollLeaveKey: t.Number(),
    StartDate: meta_types_1.tDateT,
    EndDate: meta_types_1.tDateT,
    HoursTaken: t.String(),
    PaidLeave: t.Boolean(),
}));
exports.JobPrevExpT = t.Object({
    PrevTotal: t.String(),
    SiteTotal: t.String(),
    ExpTotal: t.String(),
});
exports.JobLeaveAllowanceT = t.Object({
    LeaveKey: t.Number(),
    Criteria: t.Number(),
    Units: (0, meta_types_1.MaybeT)(t.String()),
    Per: t.Optional(t.Number()),
    OrigCriteria: t.Number(),
});
exports.JobLeaveAllowancesT = t.Record(t.Number(), exports.JobLeaveAllowanceT);
exports.JobLeaveDayShiftT = t.Object({
    Timesheet: t.Number(),
    LeaveKey: t.Optional(t.Number()),
    RunDay: t.Number(),
    Start: (0, meta_types_1.MaybeT)(exports.tTimeT),
    Finish: (0, meta_types_1.MaybeT)(exports.tTimeT),
    WorkedHrs: t.String(),
});
exports.JobLeaveDayShiftsT = t.Record(t.Number(), exports.JobLeaveDayShiftT);
exports.JobLeaveShiftsT = t.Record(t.Number(), exports.JobLeaveDayShiftsT);
const JobLeaveRecord = t.Object({
    pk: t.Union([t.String(), t.Number()]),
    blankIndex: t.Number(),
    deleted: t.Boolean(),
    original: (0, meta_types_1.MaybeT)(exports.JobLeaveDayShiftT),
    viewing: exports.JobLeaveDayShiftT,
    current: exports.JobLeaveDayShiftT,
});
const JobLeaveAllowancesGridRowT = t.Object({
    LeaveKey: t.Number(),
    Criteria: t.Number(),
    Units: (0, meta_types_1.MaybeT)(t.String()),
    Per: t.Optional(t.Number()),
    OrigCriteria: t.Number(),
});
exports.JobAllowanceRecordT = t.Object({
    pk: t.Union([t.String(), t.Number()]),
    blankIndex: t.Number(),
    deleted: t.Boolean(),
    original: (0, meta_types_1.MaybeT)(JobLeaveAllowancesGridRowT),
    viewing: JobLeaveAllowancesGridRowT,
    current: JobLeaveAllowancesGridRowT,
});
exports.JobLeaveGridRowT = t.Object({
    ID: t.Number(),
    Category: t.String(),
    Start: t.String(),
    End: (0, meta_types_1.MaybeT)(t.String()),
    TotalHrsDue: t.String(),
    LSLWeeksDue: t.String(),
    Loading: t.String(),
    Rate: t.String(),
    Reason: (0, meta_types_1.MaybeT)(t.String()),
    Reversing: t.Boolean(),
    AccrualAdjustment: t.Boolean(),
    PayEarly: t.Boolean(),
    ExcludeLSLYoS: t.Boolean(),
    CashedOut: t.Boolean(),
    CalcType: (0, meta_types_1.MaybeT)(t.Number()),
    PaidType: (0, meta_types_1.MaybeT)(t.Number()),
    Shifts: (0, meta_types_1.MaybeT)(t.Record(t.Number(), t.Record(t.Number(), exports.JobLeaveDayShiftT))),
    ShiftsGrid: t.Optional(t.Array((0, meta_types_1.MaybeT)(t.Array(JobLeaveRecord)))),
    RDOHours: t.String(),
    Due: t.String(),
    Remaining: t.String(),
    TaxWeeks: t.Number(),
    DedWeeks: t.Number(),
    Allowances: (0, meta_types_1.MaybeT)(t.Record(t.Number(), JobLeaveAllowancesGridRowT)),
    AttractsLoading: t.Boolean(),
    __isDeleted: t.Boolean(),
    __isChanged: t.Boolean(),
});
exports.SelectableAllowanceT = t.Object({
    Criteria: t.Number(),
    Allowance: t.Number(),
    Frequency: t.Number(),
    RequireEdit: t.Boolean(),
});
exports.SelectableAllowancesT = t.Record(t.Number(), exports.SelectableAllowanceT);
exports.JobLeaveHistoryT = t.Object({
    ID: t.Number(),
    Reason: (0, meta_types_1.MaybeT)(t.String()),
    Start: meta_types_1.tDateT,
    End: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    LoadingStartDate: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    LoadingEndDate: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    Category: t.String(),
    TaxWeeks: t.Number(),
    DedWeeks: t.Number(),
    Payruns: t.Number(),
    TotalHrsDue: t.String(),
    RDOHours: t.String(),
    LSLWeeksDue: t.String(),
    Rate: t.String(),
    ShiftLeave: t.Number(),
    Reversing: t.Boolean(),
    AccrualAdjustment: t.Boolean(),
    CalcType: (0, meta_types_1.MaybeT)(t.Number()),
    Loading: t.String(),
    AttractsLoading: t.Boolean(),
    PayEarly: t.Boolean(),
    ExcludeLSLYoS: t.Boolean(),
    CashedOut: t.Boolean(),
    RunFirstPaid: (0, meta_types_1.MaybeT)(t.Number()),
    ExcludeYoSCat: t.Boolean(),
    Archived: t.Boolean(),
    PaidType: (0, meta_types_1.MaybeT)(t.Number()),
    Allowances: (0, meta_types_1.MaybeT)(exports.JobLeaveAllowancesT),
    Shifts: (0, meta_types_1.MaybeT)(exports.JobLeaveShiftsT),
    Remaining: t.String(),
    Due: t.String(),
    NoCerts: t.Number(),
    PayPeriodImported: t.Number(),
});
exports.JobLeaveHistoriesT = t.Record(t.Number(), exports.JobLeaveHistoryT);
exports.LinkedJobsT = t.Object({
    LinkedJob: t.Number(),
    UsingJob: t.Number(),
    OrigKey: t.Number(),
});
exports.JobDetailsT = t.Object({
    Accruals: t.Optional(t.Record(t.Number(), exports.JobLeaveAccrualT)),
    AddLeaveShiftCounts: t.Optional(exports.JobAddLeaveShiftCountsT),
    Allowances: t.Optional(t.Record(t.Number(), t.Object({
        ID: t.Number(),
        AllowKey: t.Number(),
        StartDate: meta_types_1.tDateT,
        EndDate: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
        AlwaysPay: t.Boolean(),
        Amount: t.String(),
        AllowAction: t.String(),
    }))),
    AnnualLeave: t.Optional((0, meta_types_1.MaybeT)(exports.JobAnnualLeaveT)),
    AveHrsPerWeek: t.Optional(t.String()),
    BaseRate: t.Optional(t.String()),
    CostCentres: t.Optional(exports.JobCostCentresT),
    DomViolenceLeave: t.Optional(exports.JobDomViolenceLeaveT),
    HolLoadingPaid: t.Optional(t.String()),
    LSL: t.Optional(exports.JobLSLT),
    LSLAnniv: t.Optional(meta_types_1.tDateT),
    LSLExclDays: t.Optional(exports.JobLSLExclDaysT),
    LeaveHistory: t.Optional(exports.JobLeaveHistoriesT),
    LinkedJobs: t.Optional(t.Record(t.Number(), exports.LinkedJobsT)),
    NewJob: t.Optional(t.Boolean()),
    Penalties: t.Optional(exports.JobPenaltiesT),
    PrevExp: t.Optional(exports.JobPrevExpT),
    SelectableAllowances: t.Optional(exports.SelectableAllowancesT),
    SickLeave: t.Optional(exports.JobSickLeaveT),
    EmplUsed: t.Optional(t.Boolean()),
});
exports.PayrollJobT = t.Object({
    ID: t.Number(),
    Employee: t.Number(),
    ClassKey: t.Number(),
    Company: t.Number(),
    CurrPayPoint: t.Number(),
    MinContractHrs: (0, meta_types_1.MaybeT)(t.String()),
    MaxContractHrs: (0, meta_types_1.MaybeT)(t.String()),
    JobStartDate: meta_types_1.tDateT,
    JobEndDate: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    SiteExpHours: t.String(),
    ArchSiteExpHours: t.String(),
    TermType: (0, meta_types_1.MaybeT)(t.String()),
    Contractor: t.Boolean(),
    DefaultJob: t.Boolean(),
    AnnivDate: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    SickAnnivDate: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    LongSAnniv: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    LSLAnnivDateAdj: t.Number(),
    WorkType: t.String(),
    PayMethod: t.Number(),
    PubHolsOpt: t.Boolean(),
    PHBR: t.Boolean(),
    ADOOpt: t.Boolean(),
    LoadAnnLve: t.Number(),
    NoLoadAnnLve: t.Number(),
    PaidHours: t.String(),
    PaidWeeks: t.Number(),
    AnnLveLoadOwe: t.String(),
    AlLoadAdj: t.String(),
    AnnLvePaid: t.String(),
    AccSick: t.String(),
    MoveSick: t.String(),
    DumpYTDSick: t.String(),
    SickDumpHrs: t.String(),
    PrevSickDump: t.String(),
    NoCertSick: t.Number(),
    SickAveHrsPerWk: (0, meta_types_1.MaybeT)(t.String()),
    RDOAcc: t.String(),
    RDOMove: t.String(),
    PrevExpHours: t.String(),
    AccSun: t.Number(),
    AccSat: t.Number(),
    SpecBaseRate: (0, meta_types_1.MaybeT)(t.String()),
    ShiftWorkType: (0, meta_types_1.MaybeT)(t.Number()),
    SkillsStartDate: meta_types_1.tDateT,
    LastYearExpChange: meta_types_1.tDateT,
    DeathBenefitType: (0, meta_types_1.MaybeT)(t.String()),
    AccLieu: t.String(),
    LegacyKey: (0, meta_types_1.MaybeT)(t.String()),
    PreCADate: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    Notes: (0, meta_types_1.MaybeT)(t.String()),
    DynamicPS: t.Boolean(),
    ICEmployees: t.Boolean(),
    AnnLveReport: t.String(),
    RateFixedAve: t.String(),
    LastAveRateReset: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    LegacyRateAve: t.String(),
    TerminatingDate: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    jobDetails: t.Optional(exports.JobDetailsT),
    LastPaid: t.Optional(meta_types_1.tDateT),
    CostCentres: t.Optional(t.Array(t.Number())),
});
exports.PayrollRecordPersSuperT = t.Object({
    Amount: t.String(),
    Type: t.Number(),
    PlanName: t.String(),
    FundName: t.String(),
    PersSuperName: t.String(),
});
exports.PayrollRecordDeductionT = t.Object({
    Type: t.Number(),
    Amount: t.String(),
    Name: t.String(),
});
exports.PayrollRecordPaymentT = t.Object({
    ID: t.Number(),
    DatePaid: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    BankBSB: (0, meta_types_1.MaybeT)(t.String()),
    BankAccount: (0, meta_types_1.MaybeT)(t.String()),
    ChequeNumber: (0, meta_types_1.MaybeT)(t.String()),
    PayMethod: t.String(),
    Amount: t.String(),
    PrePayment: t.Boolean(),
});
exports.PayrollRecordPayRateT = t.Object({
    PayrollKey: t.Number(),
    LowerLimit: t.Number(),
    RateValue: t.String(),
    Hours: t.String(),
    Amount: t.String(),
    ShiftName: t.String(),
    ID: t.Number(),
});
exports.PayrollRecordPubHolT = t.Object({
    ID: t.Number(),
    PubHolName: t.String(),
    Rate: t.String(),
    Hours: t.String(),
    Type: t.String(),
    Amount: t.String(),
});
exports.PayrollRecordAllowanceT = t.Object({
    ID: t.Number(),
    AllowKey: t.Number(),
    Amount: t.String(),
    Name: t.String(),
});
exports.PayrollRecordLeaveT = t.Object({
    PayrollKey: t.Number(),
    Amount: t.String(),
    Hours: t.String(),
    Loading: t.String(),
    NoCertSick: t.Number(),
    CatName: t.String(),
    Rate: t.String(),
    ID: t.Number(),
});
exports.PayrollRecordCostSplitT = t.Object({
    ID: t.Number(),
    PCSplit: t.String(),
    Name: t.String(),
});
exports.PayrollRecordTermLeaveT = t.Object({
    PayrollKey: t.Number(),
    Amount: t.String(),
    Hours: t.String(),
    Loading: t.String(),
    CatName: t.String(),
    Rate: t.String(),
    ID: t.Number(),
});
exports.PayrollRecordLumpET = t.Object({
    TSKey: t.Number(),
    PRKey: t.Number(),
    FinYr: t.Number(),
    Amount: t.Number(),
});
exports.PayrollRecordLumpEsT = t.Record(t.String(), exports.PayrollRecordLumpET);
exports.PayrollRecordJobT = t.Object({
    PayrollKey: t.Number(),
    EmplKey: t.Number(),
    JobCode: t.Number(),
    MiscTS: (0, meta_types_1.MaybeT)(t.Number()),
    RevTS: (0, meta_types_1.MaybeT)(t.Number()),
    BaseRate: t.String(),
    Award: t.String(),
    Classification: t.String(),
    WorkType: t.String(),
    HolLoadingPaid: t.String(),
    CasLoading: t.String(),
    TaxedAdjustment: t.String(),
    TaxOnAdjustment: t.String(),
    UntaxedAdjustment: t.String(),
    Refund: t.String(),
    RefundedTax: t.String(),
    NAPSASurplus: t.String(),
    LumpE: t.String(),
    LumpEs: exports.PayrollRecordLumpEsT,
    SuperGuar: t.String(),
    SuperAward: t.String(),
    SuperAdjustment: t.String(),
    SuperGrossAdjustment: t.String(),
    WorkedWeeks: t.Number(),
    SalaryPackAllow: (0, meta_types_1.MaybeT)(t.String()),
    SalaryPackPortion: (0, meta_types_1.MaybeT)(t.String()),
    CompoLumpSum: t.String(),
    PayRates: t.Record(t.Number(), exports.PayrollRecordPayRateT),
    PayRatesLength: t.Number(),
    PubHols: t.Record(t.Number(), exports.PayrollRecordPubHolT),
    PubHolsLength: t.Number(),
    Allowances: t.Record(t.Number(), exports.PayrollRecordAllowanceT),
    AllowancesLength: t.Number(),
    Leave: t.Record(t.Number(), exports.PayrollRecordLeaveT),
    LeaveLength: t.Number(),
    PayrollSplits: t.Record(t.Number(), exports.PayrollRecordCostSplitT),
    PayrollSplitsLength: t.Number(),
    TermLeave: t.Record(t.Number(), exports.PayrollRecordTermLeaveT),
    TermLeaveLength: t.Number(),
    ETPAmount: t.String(),
});
exports.PayrollRecordJobTotalT = t.Object({
    ShiftPay: t.String(),
    Allowances: t.String(),
    LeaveGross: t.String(),
    Adjustment: t.String(),
    Gross: t.String(),
    RateHours: t.String(),
    LeaveAmount: t.String(),
    LeaveLoading: t.String(),
    LeaveHours: t.String(),
    PubHolHours: t.String(),
    PubHolAmount: t.String(),
    TermLeaveHours: t.String(),
    TermLeaveAmount: t.String(),
    TermLeaveLoading: t.String(),
    TerminationTotal: t.String(),
    SickLeaveNoCert: t.Number(),
    SickLeaveNoCertYTD: t.Number(),
});
exports.PayrollRecordDetailsT = t.Object({
    Employees: t.Object({
        PersSuper: t.Record(t.Number(), exports.PayrollRecordPersSuperT),
        PersSuperLength: t.Number(),
        PersSuperTotal: t.String(),
        Deductions: t.Record(t.Number(), exports.PayrollRecordDeductionT),
        DeductionsLength: t.Number(),
        DeductionsTotal: t.String(),
        Payments: t.Record(t.Number(), exports.PayrollRecordPaymentT),
    }),
    Jobs: t.Record(t.Number(), exports.PayrollRecordJobT),
    JobTotals: t.Record(t.Number(), exports.PayrollRecordJobTotalT),
});
exports.PayrollRecordListItemT = t.Object({
    PayrollEmpl: t.Number(),
    Employee: t.Number(),
    TaxAmount: t.String(),
    NetAmount: t.String(),
    GrossAmount: t.String(),
    TaxWeeks: t.Number(),
    DeductionWeeks: t.Number(),
    CurrTaxCode: t.String(),
    Notes: t.String(),
    DeductTotal: t.String(),
    OccSuperTotal: t.String(),
    PersSuperTotal: t.String(),
    RateTotal: t.String(),
    AllowanceTotal: t.String(),
    LeaveTotal: t.String(),
    TerminationTotal: t.String(),
    PubHolTotal: t.String(),
    Adjustments: t.String(),
    CasLoading: t.String(),
    TaxAdjustment: t.String(),
    MiscCount: t.Number(),
    RevCount: t.Number(),
    TermCount: t.Number(),
    ETPAmount: t.String(),
    details: t.Optional(t.Object({
        payrollDetails: exports.PayrollRecordDetailsT,
        defaultOpen: t.Number(),
    })),
});
exports.PayrollRecordsListT = t.Record(t.Number(), exports.PayrollRecordListItemT);
exports.PayrollRecordsT = t.Record(t.Number(), exports.PayrollRecordsListT);
exports.PayrollRecordT = t.Object({
    Employee: t.Number(),
    details: t.Object({
        payrollDetails: exports.PayrollRecordDetailsT,
        defaultOpen: t.Number(),
    }),
});
exports.JobAllowanceT = t.Object({
    Allowance: t.Number(),
    Amount: t.String(),
    AllowAction: t.String(),
    Ignore: t.Boolean(),
});
exports.JobAllowancesT = t.Record(t.Number(), exports.JobAllowanceT);
exports.TimesheetDeductionT = t.Object({
    DeductID: t.Number(),
    Reversing: t.Boolean(),
    Amount: t.String(),
    Type: t.Number(),
    Ignore: t.Boolean(),
});
exports.TimesheetDeductionsT = t.Record(t.Number(), exports.TimesheetDeductionT);
exports.TimesheetShiftAllowanceT = t.Object({
    Shift: t.String(),
    Criteria: t.Number(),
    Per: t.Number(),
    Units: (0, meta_types_1.MaybeT)(t.String()),
    OrigCriteria: t.Number(),
});
exports.TimesheetPayrunAllowanceT = t.Object({
    Criteria: t.Number(),
    Per: t.Number(),
    Units: (0, meta_types_1.MaybeT)(t.String()),
    OrigCriteria: t.Number(),
});
exports.TimesheetShiftT = t.Object({
    ID: t.String(),
    Shift: (0, meta_types_1.MaybeT)(t.Number()),
    RunDay: t.Number(),
    Start: (0, meta_types_1.MaybeT)(exports.tTimeT),
    Finish: (0, meta_types_1.MaybeT)(exports.tTimeT),
    WorkedHrs: t.String(),
    UnpaidHrs: t.String(),
    TimeInLieuHrs: t.String(),
    IgnoreShift: t.Boolean(),
    Leave: (0, meta_types_1.MaybeT)(t.String()),
    Facility: (0, meta_types_1.MaybeT)(t.Number()),
    Facility2: (0, meta_types_1.MaybeT)(t.Number()),
    RostArea: t.Number(),
    ShiftAllowances: t.Array(exports.TimesheetShiftAllowanceT),
    BoostedHours: (0, meta_types_1.MaybeT)(t.String()),
});
exports.TimesheetDayShiftsT = t.Record(t.String(), exports.TimesheetShiftT);
exports.LumpET = t.Object({
    ID: t.String(),
    Year: t.Number(),
    Amount: t.String(),
});
exports.TimesheetDetailsT = t.Object({
    Shifts: t.Record(t.Number(), exports.TimesheetDayShiftsT),
    SickLeave: t.Object({
        Accrued: t.Number(),
        EmplAccrued: t.Number(),
        NoCertSickDays: t.Number(),
    }),
    JobAllowances: exports.JobAllowancesT,
    PayrunAllowances: t.Record(t.Number(), exports.TimesheetPayrunAllowanceT),
    Deductions: exports.TimesheetDeductionsT,
    SelectableAllowances: exports.SelectableAllowancesT,
    LumpE: t.Record(t.String(), exports.LumpET),
});
exports.TimesheetT = t.Object({
    ID: t.Number(),
    PayrunEmpl: t.Number(),
    Employee: t.Number(),
    PayPeriod: t.Number(),
    Job: t.Number(),
    ALLoadingPaid: t.String(),
    TaxedAdjustment: t.String(),
    TaxOnAdjustment: t.String(),
    UntaxedAdjustment: t.String(),
    RevShiftTS: (0, meta_types_1.MaybeT)(t.Number()),
    RevShiftPeriod: t.Number(),
    PrePayPeriod: (0, meta_types_1.MaybeT)(t.Number()),
    CompoLumpSum: t.String(),
    Refund: t.String(),
    RefundedTax: t.String(),
    TaxWeeks: t.Number(),
    DeductionWeeks: t.Number(),
    Notes: (0, meta_types_1.MaybeT)(t.String()),
    MiscTSBSOption: t.Number(),
    QEAdjustment: t.String(),
    SGAdjustment: t.String(),
    timesheetDetails: t.Optional(exports.TimesheetDetailsT),
});
exports.ReportParamsT = t.Record(t.String(), t.Array(t.Object({
    Key: t.String(),
    Default: t.Boolean(),
    Type: t.String(),
    Label: t.String(),
})));
exports.EOYFBDeductionT = t.Object({
    Employee: t.Number(),
    Deduction: (0, meta_types_1.MaybeT)(t.Number()),
});
exports.LoadedDataT = t.Object({
    employees: t.Optional((0, meta_types_1.ModelTypeT)(exports.EmployeeT)),
    jobs: t.Optional((0, meta_types_1.ModelTypeT)(exports.PayrollJobT)),
    payrollRecords: t.Optional(exports.PayrollRecordsT),
    reportJobs: t.Optional(t.Record(t.Number(), exports.ReportJobPayrollT)),
    timesheets: t.Optional(t.Record(t.Number(), (0, meta_types_1.MaybeT)((0, meta_types_1.ModelTypeT)(exports.TimesheetT)))),
    eoyFBDeductions: t.Optional(t.Record(t.Number(), t.Record(t.Number(), exports.EOYFBDeductionT))),
    allowances: t.Optional(t.Boolean()),
    deductions: t.Optional(t.Boolean()),
});
exports.ReportT = t.Object({
    Index: t.Number(),
    Group: t.String(),
    Title: t.String(),
    Key: t.String(),
    Available: t.Boolean(),
    Brokerage: t.Optional(t.Boolean()),
});
exports.TimesheetExtrasChangesT = t.Record(t.Number(), t.Record(t.Number(), t.Object({
    TimeInLieuHrs: t.Number(),
    UnpaidHrs: t.Number(),
    RostArea: t.Number(),
    Facility: t.Number(),
    Facility2: t.Number(),
})));
exports.SuperBankT = t.Object({
    ID: t.Number(),
    BSB: t.String(),
    Account: t.String(),
    Name: t.String(),
    Ref: t.String(),
});
exports.SuperSMSFT = t.Object({
    SuperFund: t.Number(),
    ABN: t.String(),
    ElectronicServiceAddress: t.String(),
    BSB: t.String(),
    Account: t.String(),
    AccountName: t.String(),
    Ref: t.String(),
});
exports.RosterAccessTypesT = t.Object({
    ID: t.Number(),
    Name: t.String(),
});
exports.UsedClassificationsT = t.Object({
    ID: t.Number(),
});
exports.IncrementingT = t.Object({
    PayPoint: t.Number(),
    ClassKey: t.Number(),
    Limit1: t.String(),
    Limit2: t.String(),
});
exports.IncrementGroupT = (0, meta_types_1.ModelTypeT)(exports.IncrementingT);
exports.CountryT = t.Object({
    Code: t.String(),
    Name: t.String(),
});
exports.NameValNumT = t.Object({
    Name: t.String(),
    Value: t.Number(),
});
exports.NameValStrT = t.Object({
    Name: t.String(),
    Value: t.String(),
});
exports.CTaxCodesT = t.Object({
    NoTFN: t.String(),
    NoTaxThresh: t.String(),
    TaxThresh: t.String(),
    NoTFNForeignRes: t.String(),
    NonRes: t.String(),
    MediExempt: t.String(),
    PenSingle: t.String(),
    PenIllness: t.String(),
    PenMarried: t.String(),
    WorkHol: t.String(),
    NoTFNWorkHol: t.String(),
});
exports.CTaxExemptionsT = t.Object({
    Applying: t.String(),
    UnderAge: t.String(),
    Pensioner: t.String(),
    NotApplicable: t.String(),
});
exports.AllowCriteriaSeqItemT = t.Object({
    Criteria: t.Number(),
    LowerLimit: t.Number(),
    PermRate: t.String(),
    CasRate: t.String(),
    ID: t.String(),
});
exports.AllowCriteriaSeqT = t.Record(t.Number(), exports.AllowCriteriaSeqItemT);
exports.GCDeductionsT = t.Object({
    Code: t.String(),
    GCDeductKey: t.Number(),
    Name: t.String(),
});
exports.LoadCheckT = t.Object({
    areaAdded: t.Optional(t.Boolean()),
});
exports.PayrollShiftT = t.Object({
    ID: t.Number(),
    Award: t.Number(),
    ShiftType: t.Number(),
    Name: t.String(),
    PermRate: t.String(),
    CasRate: t.String(),
    MonToFri: t.Boolean(),
    Sat: t.Boolean(),
    Sun: t.Boolean(),
    PubHol: t.Boolean(),
    Perm: t.Boolean(),
    PartTime: t.Boolean(),
    Casual: t.Boolean(),
    ShiftWorkType: (0, meta_types_1.MaybeT)(t.Number()),
    DateInactive: (0, meta_types_1.MaybeT)(meta_types_1.tDateT),
    Notes: (0, meta_types_1.MaybeT)(t.String()),
    UsedShift: t.Optional(t.Boolean()),
});
exports.ShiftInclusionT = t.Object({
    ID: t.String(),
    Award: t.Number(),
    ShiftType: t.Number(),
    AwardInclude: t.Boolean(),
    AwardUseBase: t.Boolean(),
    GuarInclude: t.Number(),
    GuarUseBase: t.Boolean(),
    ADOInclude: t.Boolean(),
    SLInclude: t.Boolean(),
    ALInclude: t.Boolean(),
    LSLInclude: t.Boolean(),
    PenaltyInclude: t.Boolean(),
    PenaltyHourInclude: t.Boolean(),
    CasLoadingInclude: t.Boolean(),
    SiteInclude: t.Boolean(),
});
exports.AwardHolRateT = t.Object({
    ID: t.String(),
    HolType: t.String(),
    Award: t.Number(),
    ShiftWorkType: t.Number(),
    PermRate: (0, meta_types_1.MaybeT)(t.String()),
    CasRate: (0, meta_types_1.MaybeT)(t.String()),
    LoPermRate: (0, meta_types_1.MaybeT)(t.String()),
    LoCasRate: (0, meta_types_1.MaybeT)(t.String()),
    AllShiftHours: t.Boolean(),
});
exports.LoadingAveMethodT = t.Object({
    ID: t.String(),
    Name: t.String(),
});
exports.SickMethodT = t.Object({
    ID: t.String(),
    Name: t.String(),
});
exports.SLSeqT = t.Object({
    ID: t.String(),
    Award: t.Number(),
    LowerLimit: t.String(),
    DaysAccrued: t.String(),
    AutoBalance: t.Boolean(),
});
exports.LSLSeqT = t.Object({
    ID: t.String(),
    Award: t.Number(),
    LowerLimit: t.String(),
    WeeksAccrued: t.String(),
});
exports.AddSeqT = t.Object({
    ID: t.String(),
    Award: t.Number(),
    LowerLimit: t.String(),
    WeeksAccrued: t.String(),
});
exports.AddShiftWkTypeT = t.Object({
    ID: t.String(),
    Award: t.Number(),
    ShiftWorkType: t.Number(),
});
exports.SeqShiftT = t.Object({
    ID: t.String(),
    ShiftKey: t.Number(),
    LowerLimit: t.Number(),
    PermRate: t.String(),
    CasRate: t.String(),
});
exports.PayrollShiftAllowanceT = t.Object({
    ID: t.String(),
    Shift: t.Number(),
    Allow: t.Number(),
    PermRate: t.String(),
    CasRate: t.String(),
    AllowTest: t.Boolean(),
    PenaltyReplacement: t.Boolean(),
});
exports.CalcShiftRateT = t.Object({
    ShiftKey: t.Number(),
    StartTime: (0, meta_types_1.MaybeT)(t.Number()),
    FinishTime: (0, meta_types_1.MaybeT)(t.Number()),
    MajHrsCutOff: (0, meta_types_1.MaybeT)(t.Number()),
    AllShiftHours: t.Boolean(),
    MinHrsWorked: t.String(),
    MinNumShifts: t.Number(),
    DoAllowTest: t.Boolean(),
    ContainsMajWrkHrs: t.Boolean(),
});
exports.CompanyBankT = t.Object({
    ID: t.String(),
    BankBSB: t.String(),
    Account: t.String(),
    AccNumFormatted: t.String(),
    AccountName: t.String(),
    PayABA: (0, meta_types_1.MaybeT)(t.Number()),
    DeductABA: (0, meta_types_1.MaybeT)(t.Number()),
    SuperABA: (0, meta_types_1.MaybeT)(t.Number()),
});
exports.CHFormatT = t.Object({
    ID: t.String(),
    CHRego: t.Number(),
    Format: t.Number(),
    SuperFund: t.Number(),
    DefaultFormat: t.Boolean(),
});
exports.ABADefinitionT = t.Object({
    ID: t.Number(),
    FileName: t.String(),
    PayDesc: t.String(),
    PayNum: (0, meta_types_1.MaybeT)(t.String()),
    PayRef: t.String(),
    PayRemit: (0, meta_types_1.MaybeT)(t.String()),
    TraceAccountNum: (0, meta_types_1.MaybeT)(t.String()),
    TraceBSB: (0, meta_types_1.MaybeT)(t.String()),
    ReleaseDay: t.Number(),
    SelfBalancing: t.Boolean(),
});
exports.ATOTransferT = t.Object({
    ID: t.String(),
    BankBSB: t.String(),
    Account: t.String(),
    PayFrequency: t.Number(),
    TaxABA: t.Number(),
});
exports.TransferFormatT = t.Object({
    ID: t.Number(),
    TransferTypeID: t.Number(),
    Name: t.String(),
});
exports.TransferTypeT = t.Object({
    ID: t.Number(),
    Name: t.String(),
});
exports.EOYFBAdjT = t.Object({
    Employee: t.Number(),
    TaxYear: t.Number(),
    FBAdj: t.Number(),
});
exports.TaxRateGeneralT = t.Object({
    Code: t.String(),
    Name: t.String(),
    Value: t.Number(),
});
exports.PayrollSTPEventT = t.Object({
    ID: t.Number(),
    Rego: t.Number(),
    PayPeriod: t.Number(),
    UpdateTS: meta_types_1.tDatetimeT,
    Action: t.Number(),
    State: t.Number(),
    ATOStatus: (0, meta_types_1.MaybeT)(t.String()),
    Active: t.Boolean(),
    SubmissionID: (0, meta_types_1.MaybeT)(t.String()),
    BureauHash: (0, meta_types_1.MaybeT)(t.String()),
    ATOHash: (0, meta_types_1.MaybeT)(t.String()),
    Accepter: (0, meta_types_1.MaybeT)(t.String()),
    AcceptTimeStamp: (0, meta_types_1.MaybeT)(meta_types_1.tDatetimeT),
    Notes: (0, meta_types_1.MaybeT)(t.String()),
    ClientApproved: t.Boolean(),
});
exports.TaxRateT = t.Object({
    ID: t.String(),
    Code: t.String(),
    LowerLimit: t.Number(),
    ValueA: t.Number(),
    ValueB: t.Number(),
    LastMod: meta_types_1.tDatetimeT,
});
exports.STPHistoryT = t.Object({
    Event: t.Number(),
    TimeStamp: meta_types_1.tDatetimeT,
    Signer: t.String(),
    File: t.Number(),
});
exports.STPApprovalStateT = t.Object({
    Event: t.Number(),
    EmplList: t.String(),
    TickIndex: t.Number(),
});
exports.STPEmplT = t.Object({
    ID: t.Number(),
    Surname: t.String(),
    FGiven: t.String(),
    FullName: t.String(),
});
exports.STPActionT = t.Object({
    ID: t.Number(),
    Name: t.String(),
});
exports.STPStateT = t.Object({
    ID: t.Number(),
    Name: t.String(),
});
exports.AllowanceExtraT = t.Object({
    FYUsed: t.Boolean(),
    IsNew: t.Boolean(),
});
exports.AllowanceExtrasT = t.Record(t.Number(), exports.AllowanceExtraT);
exports.DeductionExtraT = t.Object({
    FYUsed: t.Boolean(),
    IsNew: t.Boolean(),
});
exports.ReportParamT = t.Object({
    ID: t.Number(),
    Report: t.String(),
    Name: t.String(),
    Value: t.String(),
});
exports.PayrollPayRatesT = t.Record(t.Number(), t.Array(exports.PayrollRateT));
exports.PayrollRatesT = t.Record(t.Number(), exports.PayrollPayRatesT);
exports.ExpCalcMethodsT = t.Object({
    ID: t.Number(),
    Name: t.String(),
});
exports.EmplCompT = t.Object({
    ID: t.String(),
    Employee: t.Number(),
    Company: t.Number(),
    LSLAnniv: meta_types_1.tDateT,
});
exports.TFNT = t.Object({
    Employee: t.Number(),
    TFN: t.String(),
});
exports.TFNsT = (0, meta_types_1.ModelTypeT)(exports.TFNT);
exports.EmployeeOnBoardT = t.Object({
    AccountNumber: (0, meta_types_1.MaybeT)(t.String()),
    BSB: (0, meta_types_1.MaybeT)(t.String()),
    SuperFund: (0, meta_types_1.MaybeT)(t.String()),
    SuperFundNumber: (0, meta_types_1.MaybeT)(t.String()),
    SuperUSI: (0, meta_types_1.MaybeT)(t.String()),
    SuperannuationType: (0, meta_types_1.MaybeT)(t.Number()),
    SMSFName: (0, meta_types_1.MaybeT)(t.String()),
    SMSFAlias: (0, meta_types_1.MaybeT)(t.String()),
    SMSFAbn: (0, meta_types_1.MaybeT)(t.String()),
    SMSFBankBSB: (0, meta_types_1.MaybeT)(t.String()),
    SMSFBankAccNumber: (0, meta_types_1.MaybeT)(t.String()),
    SMSFBankAccName: (0, meta_types_1.MaybeT)(t.String()),
    TFN: (0, meta_types_1.MaybeT)(t.String()),
    TaxCode: (0, meta_types_1.MaybeT)(t.String()),
    TaxOptions: (0, meta_types_1.MaybeT)(t.Array(t.Number())),
    MedSurcharge: (0, meta_types_1.MaybeT)(t.String()),
    MedReductReason: (0, meta_types_1.MaybeT)(t.String()),
});
exports.PayrollErrorT = t.Object({
    Text: t.String(),
});
exports.ErrorItemT = t.Object({
    Name: t.String(),
    Weight: t.Number(),
    Errors: t.Array(exports.PayrollErrorT),
});
exports.ErrorsListT = t.Record(t.String(), exports.ErrorItemT);
exports.FileLockerFolderT = t.Object({
    ID: t.Number(),
    Parent: (0, meta_types_1.MaybeT)(t.Number()),
    Name: t.String(),
});
exports.WindowDefaultT = t.Object({
    Width: t.Number(),
    Height: t.Number(),
    XPos: t.Number(),
    YPos: t.Number(),
    ShowSidebar: t.Boolean(),
});
exports.RunTotalT = t.Object({
    Gross: t.String(),
    Tax: t.String(),
    Net: t.String(),
});
exports.RunTotalsT = t.Record(t.Number(), exports.RunTotalT);
exports.RunYearTotalsT = t.Record(t.Number(), exports.RunTotalsT);
exports.PayrollManualT = t.Recursive(x => t.Object({
    ID: t.Number(),
    Title: t.String(),
    SortingKey: t.String(),
    Markdown: t.String(),
    Children: t.Record(t.Number(), x),
}));
exports.SuperValidationDataT = t.Object({
    ID: t.Number(),
    ABN: t.String(),
    EffectiveFrom: t.String(),
    EffectiveTo: t.String(),
    Certification: (0, meta_types_1.MaybeT)(t.String()),
    USI: t.String(),
    SuperPlan: t.String(),
    ContributionRestrictions: t.Boolean(),
    BSB: t.String(),
    Account: t.String(),
    AccountName: t.String(),
    ElectronicServiceAddress: t.String(),
    SecondaryBSB: t.String(),
    SecondaryAccount: t.String(),
    SecondaryAccountName: t.String(),
    SecondaryElectronicServiceAddress: t.String(),
    SuperFund: t.String(),
});
exports.PayToAgreementT = t.Object({
    RegoKey: t.Number(),
    BankBSB: t.String(),
    BankAccount: t.String(),
    Description: t.String(),
    MaxPayments: t.Number(),
    MaxAmount: t.String(),
    AccountName: t.String(),
    UserID: t.String(),
    PayManually: t.Boolean(),
    SelfBalancing: t.Boolean(),
    OzEDISuperBSB: (0, meta_types_1.MaybeT)(t.String()),
    OzEDISuperAccount: (0, meta_types_1.MaybeT)(t.String()),
    OzEDISuperPayID: (0, meta_types_1.MaybeT)(t.String()),
    OzEDIPayment: t.Boolean(),
});
exports.OccSuperUnprocessedT = t.Object({
    Employee: t.Number(),
    Gross: t.Number(),
    SuperAdjustment: t.Number(),
});
exports.SuperUploadDataT = t.Object({
    ID: t.Number(),
    ABN: t.String(),
    SuperFund: t.Number(),
    ResubmittedFund: (0, meta_types_1.MaybeT)(t.Number()),
    PayPeriod: t.Number(),
    MessageUUID: (0, meta_types_1.MaybeT)(t.String()),
    Status: t.String(),
    MemberRegistration: t.Number(),
    PaymentReferenceNumber: t.String(),
    PaymentTotal: t.String(),
    Employees: t.Array(t.Number()),
    FundStatus: (0, meta_types_1.MaybeT)(t.String()),
    ResponseSeverity: (0, meta_types_1.MaybeT)(t.String()),
    ResponseShortDesc: (0, meta_types_1.MaybeT)(t.String()),
    ResponseLongDesc: (0, meta_types_1.MaybeT)(t.String()),
    Created: (0, meta_types_1.MaybeT)(t.String()),
    Modified: (0, meta_types_1.MaybeT)(t.String()),
    Refreshed: (0, meta_types_1.MaybeT)(t.String()),
    PaidManually: t.Boolean(),
    ABAFileCreated: (0, meta_types_1.MaybeT)(t.String()),
});
exports.SuperUploadActionT = t.Object({
    ID: t.Number(),
    UploadID: t.Number(),
    Comment: t.String(),
    LastModUser: t.Number(),
    LastModName: t.String(),
    LastMod: t.String(),
});
exports.SMSFAliasT = t.Object({
    Alias: t.String(),
    ElectronicServiceAddress: t.String(),
    EffectiveFrom: t.String(),
    EffectiveTo: t.String(),
    GatewayName: t.String(),
    Certification: t.String(),
});
exports.ConstantsT = t.Object({
    PayrunStages: t.Record(t.Number(), t.String()),
    PayrunStates: t.Record(t.String(), t.Number()),
    TaxCodes: exports.CTaxCodesT,
    TaxExemptions: exports.CTaxExemptionsT,
    MedReductReasonDef: t.String(),
    MedSurchargeDef: t.String(),
    MiscBSOptions: t.Record(t.Number(), exports.NameValNumT),
    MiscBSOptionStates: t.Record(t.String(), t.Number()),
    JKFlagValues: t.Record(t.String(), t.Number()),
    BSShiftTypes: t.Array(t.String()),
    STPStates: t.Record(t.String(), t.Number()),
    STPStatuses: t.Record(t.String(), t.String()),
    STPActions: t.Record(t.String(), t.Number()),
    SBRCIActions: t.Record(t.String(), t.Number()),
    STPHistTempName: t.String(),
    LeaveEditableAllowFreqs: t.Array(t.String()),
    BackupStageNames: t.Record(t.Number(), t.String()),
    SpecialTaxNumbers: t.Array(t.String()),
    OzEDISuperReponses: t.Object({
        UPLOAD_PRE_PROCESSING: t.String(),
        UPLOAD_PRE_PROCESSING_FAILED: t.String(),
        UPLOAD_REJECTED: t.String(),
        UPLOAD_FAILED: t.String(),
        UPLOAD_READY: t.String(),
        UPLOAD_CANCELLED: t.String(),
        UPLOAD_PAYMENT_IN_PROGRESS: t.String(),
        UPLOAD_PAYMENT_FAILED: t.String(),
        UPLOAD_PAYMENT_INCOMPLETE: t.String(),
        UPLOAD_PAYMENT_SUCCESS: t.String(),
        UPLOAD_SEND_IN_PROGRESS: t.String(),
        UPLOAD_SEND_FAILED: t.String(),
        UPLOAD_SEND_SUCCESS: t.String(),
        UPLOAD_CHECK_PASS: t.String(),
        UPLOAD_PREPROCESSING: t.String(),
        UPLOAD_PREPROCESSING_FAILED: t.String(),
        UPLOAD_RESUBMITTED: t.String(),
    }),
});
exports.StaticDataTypeT = t.Object({
    abaFrequencies: t.Optional((0, meta_types_1.ModelTypeT)(exports.ABAFrequencyT)),
    banksList: t.Optional(t.Record(t.String(), exports.BanksListT)),
    taxExemptions: t.Optional((0, meta_types_1.ModelTypeT)(exports.TaxExemptionT)),
    taxCodes: t.Optional((0, meta_types_1.ModelTypeT)(exports.TaxCodeT)),
    extraTaxOptions: t.Optional((0, meta_types_1.ModelTypeT)(exports.ExtraTaxOptionT)),
    taxWeeksDefaults: t.Optional((0, meta_types_1.ModelTypeT)(exports.TaxWeeksDefaultT)),
    salutations: t.Optional((0, meta_types_1.ModelTypeT)(exports.SalutationT)),
    postCodes: t.Optional((0, meta_types_1.ModelTypeT)(exports.PostCodeT)),
    postCodesUniq: t.Optional((0, meta_types_1.ModelTypeT)(exports.PostCodeT)),
    states: t.Optional((0, meta_types_1.ModelTypeT)(exports.StatesT)),
    sexes: t.Optional((0, meta_types_1.ModelTypeT)(exports.SexT)),
    payMethods: t.Optional((0, meta_types_1.ModelTypeT)(exports.PayMethodT)),
    payTypes: t.Optional((0, meta_types_1.ModelTypeT)(exports.PayTypeT)),
    workTypes: t.Optional(t.Record(t.String(), exports.WorkTypeT)),
    superPayTypes: t.Optional(t.Record(t.String(), exports.SuperPayTypeT)),
    superLeaveReasons: t.Optional((0, meta_types_1.ModelTypeT)(exports.SuperLeaveReasonT)),
    amountTypes: t.Optional((0, meta_types_1.ModelTypeT)(exports.AmountTypeT)),
    termTypes: t.Optional((0, meta_types_1.ModelTypeT)(exports.TermTypeT)),
    jobAllowActions: t.Optional((0, meta_types_1.ModelTypeT)(exports.JobAllowActionT)),
    loadingCalcTypes: t.Optional((0, meta_types_1.ModelTypeT)(exports.LoadingCalcTypeT)),
    leaveCategories: t.Optional(t.Record(t.String(), exports.LeaveCategoryT)),
    shiftTypes: t.Optional((0, meta_types_1.ModelTypeT)(exports.ShiftTypeT)),
    deathPayTypes: t.Optional((0, meta_types_1.ModelTypeT)(exports.DeathPayTypeT)),
    loadingPaidTypes: t.Optional((0, meta_types_1.ModelTypeT)(exports.LoadingPaidTypeT)),
    lslAccrualMethods: t.Optional((0, meta_types_1.ModelTypeT)(exports.LslAccrualMethodT)),
    basicWages: t.Optional((0, meta_types_1.ModelTypeT)(exports.BasicWageT)),
    timeRelations: t.Optional((0, meta_types_1.ModelTypeT)(exports.TimeRelationT)),
    rosterAccessTypes: t.Optional((0, meta_types_1.ModelTypeT)(exports.RosterAccessTypesT)),
    allowSexes: t.Optional((0, meta_types_1.ModelTypeT)(exports.SexT)),
    countries: t.Optional((0, meta_types_1.ModelTypeT)(exports.CountryT)),
    medicareSurcharge: t.Optional((0, meta_types_1.ModelTypeT)(exports.NameValStrT)),
    medicareReduction: t.Optional((0, meta_types_1.ModelTypeT)(exports.NameValStrT)),
    constants: t.Optional(exports.ConstantsT),
    averagingLengths: t.Optional((0, meta_types_1.ModelTypeT)(exports.NameValStrT)),
    expCalcMethods: t.Optional((0, meta_types_1.ModelTypeT)(exports.ExpCalcMethodsT)),
    odCategories: t.Optional((0, meta_types_1.ModelTypeT)(exports.NameValStrT)),
    gcAllows2: t.Optional((0, meta_types_1.ModelTypeT)(exports.NameValStrT)),
    gcDeductions: t.Optional(t.Record(t.String(), exports.GCDeductionsT)),
    superInclTypes: t.Optional((0, meta_types_1.ModelTypeT)(exports.NameValNumT)),
    loadingAveMethods: t.Optional((0, meta_types_1.ModelTypeT)(exports.LoadingAveMethodT)),
    sickMethods: t.Optional((0, meta_types_1.ModelTypeT)(exports.SickMethodT)),
    transferFormats: t.Optional((0, meta_types_1.ModelTypeT)(exports.TransferFormatT)),
    transferTypes: t.Optional((0, meta_types_1.ModelTypeT)(exports.TransferTypeT)),
    stpActions: t.Optional((0, meta_types_1.ModelTypeT)(exports.STPActionT)),
    stpStates: t.Optional((0, meta_types_1.ModelTypeT)(exports.STPStateT)),
    bankBranches: t.Optional((0, meta_types_1.ModelTypeT)(exports.BankBranchT)),
});
exports.DataModelPayrollT = t.Intersect([
    t.Object({
        facilityID: t.Number(),
        periods: (0, meta_types_1.ModelTypeT)(exports.PeriodT),
        period: t.Number(),
        lastClosedRun: t.Number(),
        lastActiveRun: t.Number(),
        firstRunInMonth: (0, meta_types_1.ModelTypeT)(exports.PeriodT),
        lastRunInMonth: (0, meta_types_1.ModelTypeT)(exports.PeriodT),
        firstRunInYear: (0, meta_types_1.ModelTypeT)(exports.PeriodT),
        lastRunInYear: (0, meta_types_1.ModelTypeT)(exports.PeriodT),
        currentYear: t.Number(),
        taxYears: t.Array(t.Number()),
        classifications: (0, meta_types_1.ModelTypeT)(exports.PayrollClassificationT),
        awards: (0, meta_types_1.ModelTypeT)(exports.AwardT),
        allowances: (0, meta_types_1.ModelTypeT)(exports.PayrollAllowanceT),
        deductGroups: (0, meta_types_1.ModelTypeT)(exports.DeductGroupT),
        deductions: (0, meta_types_1.ModelTypeT)(exports.PayrollDeductionT),
        locations: (0, meta_types_1.ModelTypeT)(exports.LocationT),
        costCentres: (0, meta_types_1.ModelTypeT)(exports.CostCentreT),
        journalAccounts: (0, meta_types_1.ModelTypeT)(exports.JournalAccountT),
        costCentres3Level: (0, meta_types_1.ModelTypeT)(exports.CostCentres3LevelT),
        superPlans: (0, meta_types_1.ModelTypeT)(exports.SuperPlanT),
        superFunds: (0, meta_types_1.ModelTypeT)(exports.SuperFundT),
        companies: (0, meta_types_1.ModelTypeT)(exports.CompanyT),
        ABNs: (0, meta_types_1.ModelTypeT)(exports.ABNT),
        clearingHouses: (0, meta_types_1.ModelTypeT)(exports.ClearingHouseT),
        facilities: (0, meta_types_1.ModelTypeT)(exports.FacilityT),
        STPEvents: (0, meta_types_1.ModelTypeT)(exports.STPEventT),
        stateVersion: t.String(),
        reportTitle: t.String(),
        isBrokerage: t.Boolean(),
        emplTaxOptions: (0, meta_types_1.ModelTypeT)(exports.EmplTaxOptionT),
        bankSplitTypes: (0, meta_types_1.ModelTypeT)(exports.BankSplitTypeT),
        shiftWorkers: (0, meta_types_1.ModelTypeT)(exports.ShiftWorkerT),
        personalSuperTypes: (0, meta_types_1.ModelTypeT)(exports.PersonalSuperTypeT),
        deductBanking: (0, meta_types_1.ModelTypeT)(exports.DeductBankingT),
        deductTypeBanking: (0, meta_types_1.ModelTypeT)(exports.DeductTypeBankingT),
        agencies: (0, meta_types_1.ModelTypeT)(exports.AgencyT),
        readOnlyObj: t.Union([exports.ReadOnlyT, t.Boolean()]),
        readOnly: t.Boolean() || true,
        persons: (0, meta_types_1.ModelTypeT)(exports.PersonT),
        allowFrequencies: (0, meta_types_1.ModelTypeT)(exports.AllowFrequencyT),
        classAllowances: (0, meta_types_1.ModelTypeT)(exports.ClassAllowanceT),
        staticHash: exports.StaticHashT,
        employeesLastMod: meta_types_1.tDatetimeT,
        jobsLastMod: meta_types_1.tDatetimeT,
        bankBranchesLastMod: meta_types_1.tDatetimeT,
        rosterAreas: (0, meta_types_1.ModelTypeT)(exports.RosterAreaT),
        publicHolidays: (0, meta_types_1.ModelTypeT)(exports.PublicHolidayT),
        shiftTypePayAllow: (0, meta_types_1.ModelTypeT)(exports.ShiftTypePayAllowT),
        cache: exports.CacheT,
        reportJobs: t.Record(t.Number(), exports.ReportJobPayrollT),
        singleReportParams: (0, meta_types_1.ModelTypeT)(exports.ReportsParamT),
        publicHolTypes: (0, meta_types_1.ModelTypeT)(exports.PublicHolTypeT),
        timeRanges: (0, meta_types_1.ModelTypeT)(exports.TimeRangeT),
        superBanks: (0, meta_types_1.ModelTypeT)(exports.SuperBankT),
        superSMSF: (0, meta_types_1.ModelTypeT)(exports.SuperSMSFT),
        allowCriteriaSeqs: t.Record(t.Number(), exports.AllowCriteriaSeqT),
        loadChecks: exports.LoadCheckT,
        awardHolRates: t.Record(t.String(), exports.AwardHolRateT),
        slSeq: (0, meta_types_1.ModelTypeT)(exports.SLSeqT),
        lslSeq: (0, meta_types_1.ModelTypeT)(exports.LSLSeqT),
        addSeq: (0, meta_types_1.ModelTypeT)(exports.AddSeqT),
        addShiftWkType: (0, meta_types_1.ModelTypeT)(exports.AddShiftWkTypeT),
        companyBanks: t.Record(t.String(), exports.CompanyBankT),
        chFormats: (0, meta_types_1.ModelTypeT)(exports.CHFormatT),
        abaDefinitions: (0, meta_types_1.ModelTypeT)(exports.ABADefinitionT),
        atoTransfers: t.Record(t.String(), exports.ATOTransferT),
        pendingPrepays: t.Boolean(),
        emplComps: t.Record(t.String(), exports.EmplCompT),
        employeesOnboard: (0, meta_types_1.ModelTypeT)(exports.EmployeeOnBoardT),
        employees: (0, meta_types_1.ModelTypeT)(exports.EmployeeT),
        jobs: (0, meta_types_1.ModelTypeT)(exports.PayrollJobT),
        isBureau: t.Boolean(),
        reportScripts: t.Record(t.Number(), t.Object({
            ID: t.Number(),
            ScriptName: t.String(),
        })),
        resetEmpls: t.Record(t.Number(), t.Array(t.Number())),
        payrollManual: t.Record(t.Number(), exports.PayrollManualT),
        payrollManualExternalReferences: t.Record(t.Number(), t.String()),
        payToAgreements: t.Optional((0, meta_types_1.ModelTypeT)(exports.PayToAgreementT)),
        occSuperUnprocessed: (0, meta_types_1.ModelTypeT)(exports.OccSuperUnprocessedT),
        superUploadData: t.Record(t.String(), t.Record(t.Number(), exports.SuperUploadDataT)),
        superUploadActions: t.Record(t.Number(), exports.SuperUploadActionT),
        awardAllowances: t.Optional((0, meta_types_1.ModelTypeT)(exports.AwardAllowanceT)),
        leaveInclusions: t.Optional((0, meta_types_1.ModelTypeT)(exports.LeaveInclusionT)),
        shiftInclusions: t.Optional((0, meta_types_1.ModelTypeT)(exports.ShiftInclusionT)),
        bankEmpl: t.Optional((0, meta_types_1.ModelTypeT)(exports.BankEmplT)),
        allowCriteria: t.Optional((0, meta_types_1.ModelTypeT)(exports.PayrollAllowCriteriaT)),
        leaveDefinedAllowances: t.Optional((0, meta_types_1.ModelTypeT)(exports.LeaveDefinedAllowanceT)),
        deductEmployees: t.Optional((0, meta_types_1.ModelTypeT)(exports.DeductEmployeeT)),
        jobSplits: t.Optional((0, meta_types_1.ModelTypeT)(exports.JobSplitT)),
        payrollRates: t.Optional(exports.PayrollRatesT),
        incrementing: t.Optional((0, meta_types_1.ModelTypeT)(exports.IncrementGroupT)),
        shifts: t.Optional((0, meta_types_1.ModelTypeT)(exports.PayrollShiftT)),
        seqShifts: t.Optional((0, meta_types_1.ModelTypeT)(exports.SeqShiftT)),
        shiftAllowances: t.Optional((0, meta_types_1.ModelTypeT)(exports.PayrollShiftAllowanceT)),
        calcShiftRates: t.Optional((0, meta_types_1.ModelTypeT)(exports.CalcShiftRateT)),
        runTotals: t.Optional(exports.RunYearTotalsT),
        eoyFBAdjs: t.Optional(t.Record(t.Number(), (0, meta_types_1.ModelTypeT)(exports.EOYFBAdjT))),
        taxRatesGeneral: t.Optional(t.Record(t.String(), exports.TaxRateGeneralT)),
        payrollSTPEvents: t.Optional((0, meta_types_1.ModelTypeT)(exports.PayrollSTPEventT)),
        taxRates: t.Optional((0, meta_types_1.ModelTypeT)(exports.TaxRateT)),
        stpHistory: t.Optional((0, meta_types_1.ModelTypeT)(exports.STPHistoryT)),
        stpApprovalState: t.Optional((0, meta_types_1.ModelTypeT)(exports.STPApprovalStateT)),
        stpEmpls: t.Optional((0, meta_types_1.ModelTypeT)(exports.STPEmplT)),
        sysValues: exports.SysValuesT,
        banks: (0, meta_types_1.ModelTypeT)(exports.BankT),
        fileLockerFolders: t.Optional((0, meta_types_1.ModelTypeT)(exports.FileLockerFolderT)),
        superValidationData: (0, meta_types_1.ModelTypeT)(exports.SuperValidationDataT),
        smsfAlias: t.Record(t.String(), exports.SMSFAliasT),
        limitedEmployees: t.Boolean(),
        limitedJobs: t.Boolean(),
        tfns: t.Optional((0, meta_types_1.MaybeT)(exports.TFNsT)),
        loadingNodes: t.Array(t.String()),
        loadedData: exports.LoadedDataT,
        selectableCostCentres: (0, meta_types_1.ModelTypeT)(exports.CostCentreT),
        reportParams: t.Optional(types_reports_1.ReportDataCacheT),
        usedClassifications: t.Optional((0, meta_types_1.ModelTypeT)(exports.UsedClassificationsT)),
        rerunEmployee: (0, meta_types_1.MaybeT)(t.Number()),
        tpeLocked: t.Boolean(),
        windowDefaults: t.Optional(t.Record(t.String(), exports.WindowDefaultT)),
        windows: t.Record(t.String(), t.Number()),
        isDev: t.Boolean(),
    }),
    exports.StaticDataTypeT,
]);
exports.UnloadedDataT = t.Object({
    employees: t.Optional((0, meta_types_1.ModelTypeT)(exports.EmployeeT)),
    jobs: t.Optional((0, meta_types_1.ModelTypeT)(exports.PayrollJobT)),
    awardAllowances: t.Optional((0, meta_types_1.ModelTypeT)(exports.AwardAllowanceT)),
    leaveInclusions: t.Optional((0, meta_types_1.ModelTypeT)(exports.LeaveInclusionT)),
    bankBranches: t.Optional((0, meta_types_1.ModelTypeT)(exports.BankBranchT)),
    bankEmpl: t.Optional((0, meta_types_1.ModelTypeT)(exports.BankEmplT)),
    allowCriteria: t.Optional((0, meta_types_1.ModelTypeT)(exports.PayrollAllowCriteriaT)),
    leaveDefinedAllowances: t.Optional((0, meta_types_1.ModelTypeT)(exports.LeaveDefinedAllowanceT)),
    deductEmployees: t.Optional((0, meta_types_1.ModelTypeT)(exports.DeductEmployeeT)),
    jobSplits: t.Optional((0, meta_types_1.ModelTypeT)(exports.JobSplitT)),
    payrollRates: t.Optional(exports.PayrollRatesT),
    usedClassifications: t.Optional((0, meta_types_1.ModelTypeT)(t.Object({ ID: t.Number() }))),
    incrementing: t.Optional((0, meta_types_1.ModelTypeT)(exports.IncrementGroupT)),
    classAllowances: t.Optional((0, meta_types_1.ModelTypeT)(exports.ClassAllowanceT)),
    allowanceExtras: t.Optional((0, meta_types_1.MaybeT)(exports.AllowanceExtrasT)),
    deductionExtras: t.Optional((0, meta_types_1.MaybeT)(t.Record(t.Number(), exports.DeductionExtraT))),
    shifts: t.Optional((0, meta_types_1.ModelTypeT)(exports.PayrollShiftT)),
    shiftInclusions: t.Optional((0, meta_types_1.ModelTypeT)(exports.ShiftInclusionT)),
    seqShifts: t.Optional((0, meta_types_1.ModelTypeT)(exports.SeqShiftT)),
    shiftAllowances: t.Optional((0, meta_types_1.ModelTypeT)(exports.PayrollShiftAllowanceT)),
    calcShiftRates: t.Optional((0, meta_types_1.ModelTypeT)(exports.CalcShiftRateT)),
    eoyFBAdjs: t.Optional(t.Record(t.Number(), (0, meta_types_1.ModelTypeT)(exports.EOYFBAdjT))),
    eoyFBDeductions: t.Optional(t.Record(t.Number(), t.Record(t.Number(), exports.EOYFBDeductionT))),
    taxRatesGeneral: t.Optional(t.Record(t.String(), exports.TaxRateGeneralT)),
    payrollSTPEvents: t.Optional((0, meta_types_1.ModelTypeT)(exports.PayrollSTPEventT)),
    taxRates: t.Optional((0, meta_types_1.ModelTypeT)(exports.TaxRateT)),
    stpHistory: t.Optional((0, meta_types_1.ModelTypeT)(exports.STPHistoryT)),
    stpApprovalState: t.Optional((0, meta_types_1.ModelTypeT)(exports.STPApprovalStateT)),
    stpEmpls: t.Optional(t.Object({
        stpEmpls: t.Optional((0, meta_types_1.ModelTypeT)(exports.STPEmplT)),
        payrunEmpls: t.Optional((0, meta_types_1.ModelTypeT)(exports.STPEmplT)),
    })),
    tfns: t.Optional((0, meta_types_1.MaybeT)(exports.TFNsT)),
    fileLockerFolders: t.Optional((0, meta_types_1.ModelTypeT)(exports.FileLockerFolderT)),
    runTotals: t.Optional(exports.RunTotalsT),
    payrollEmplSuper: t.Optional(t.Record(t.Number(), t.Record(t.Number(), t.Record(t.Number(), t.Number())))),
});
exports.TPEErrorT = t.Object({
    TestName: t.Optional(t.String()),
    TestDesc: t.Optional(t.String()),
    ErrorRecs: t.Optional(t.Array(t.String())),
});
exports.TPEResultT = t.Object({
    status: t.Number(),
    data: t.Union([
        t.Optional(t.Array(exports.TPEErrorT)),
        t.Optional(t.Record(t.String(), t.String())),
    ]),
    message: t.String(),
});
exports.STPSubmissionStatusT = t.Object({
    ABN: t.String(),
    ATOStatus: t.String(),
    CompanyFailed: t.Boolean(),
    CompanyFailedMessage: t.Optional(t.String()),
    EmplErrorCodes: t.Object({
        EmplError: t.Array(t.Object({
            EmplCode: t.Number(),
            Reason: t.String(),
        })),
    }),
    EventId: t.Number(),
    OnBoardCodes: t.Object({
        EmplError: t.Array(t.Object({
            EmplCode: t.Number(),
            Reason: t.String(),
        })),
    }),
    PPKey: t.Number(),
    PPStart: t.String(),
});
exports.STPXmlSubmissionDataT = t.Object({
    ABN: t.String(),
    ATOStatus: t.String(),
    CompanyFailed: t.Boolean(),
    CompanyFailedMessage: t.Optional(t.String()),
    EmplErrorCodes: t.Union([
        t.Object({
            EmplError: t.Union([
                t.Array(t.Object({
                    EmplCode: t.Number(),
                    Reason: t.String(),
                })),
                t.Object({
                    EmplCode: t.Number(),
                    Reason: t.String(),
                }),
            ]),
        }),
        t.String(),
    ]),
    EventId: t.Number(),
    OnBoardCodes: t.Union([
        t.Object({
            EmplError: t.Union([
                t.Array(t.Object({
                    EmplCode: t.Number(),
                    Reason: t.String(),
                })),
                t.Object({
                    EmplCode: t.Number(),
                    Reason: t.String(),
                }),
            ]),
        }),
        t.String(),
    ]),
    PPKey: t.Number(),
    PPStart: t.String(),
});
exports.STPxmlDataT = t.Object({
    FacilityStatus: t.Object({
        ABNs: t.Union([
            t.Object({
                SubmissionStatus: t.Array(exports.STPXmlSubmissionDataT),
            }),
            t.String(),
        ]),
    }),
});
exports.JobTermTotalT = t.Object({
    PayrollKey: t.Number(),
    Pre83: t.String(),
    Post83Untaxed: t.String(),
    Post83Leave: t.String(),
    Post94Invalidity: t.String(),
    TaxDeductions: t.String(),
    ETPTaxDeduction: t.String(),
    ETPTaxAdjustment: t.String(),
    AssessableAmount: t.String(),
    TaxFreeAmount: t.String(),
    ExcessiveAmount: t.String(),
    LumpA: t.String(),
    LumpB: t.String(),
    JobTaxedGross: t.String(),
    PaidSavedLoad: t.String(),
    DeductInclude: t.Boolean(),
    PersSuperInclude: t.Boolean(),
    RolloverReceiveJob: (0, meta_types_1.MaybeT)(t.Number()),
    CAReceiveJob: (0, meta_types_1.MaybeT)(t.Number()),
    PILON: t.String(),
    SevPay: t.String(),
    Gratuity: t.String(),
    Compensation: t.String(),
});
exports.PayrollRosterImporterProgressT = t.Object({
    dataFetched: t.Number(),
    clearedExistingTimesheets: t.Number(),
    rosterStatus: t.Record(t.String(), t.Object({
        rosterName: t.String(),
        dataFetched: t.Number(),
        shiftsImported: t.Number(),
        gapsImported: t.Number(),
        leaveImported: t.Number(),
        allowancesImported: t.Number(),
    })),
});
exports.PayrollUpgradeProgressResponseT = t.Record(t.Number(), t.Object({
    Version: t.String(),
    MaxVersion: t.String(),
    Progress: t.Number(),
}));
exports.CompanyTransferProgressResponseT = t.Object({
    dataLoad: t.Number(),
    employeeCreation: t.Number(),
    jobCreation: t.Number(),
    timesheetCreation: t.Number(),
    rosterUpdates: t.Record(t.String(), t.Number()),
    unavailability: t.Number(),
    scheduledLeave: t.Number(),
    accountLinking: t.Number(),
    jobTerminations: t.Number(),
});
exports.GeneratorTypesT = t.Union([
    t.Literal('ABADefinitions_GEN'),
    t.Literal('Agency_GEN'),
    t.Literal('Allowances_GEN'),
    t.Literal('AllowCriteria_GEN'),
    t.Literal('Award_GEN'),
    t.Literal('Banks_GEN'),
    t.Literal('ChequeNum_GEN'),
    t.Literal('Classifications_GEN'),
    t.Literal('CostCentres_GEN'),
    t.Literal('DeductEmpl_GEN'),
    t.Literal('DeductType_GEN'),
    t.Literal('EmplEntity_GEN'),
    t.Literal('Employee_GEN'),
    t.Literal('GLItem_GEN'),
    t.Literal('JobsParams_GEN'),
    t.Literal('JobsReports_GEN'),
    t.Literal('Job_GEN'),
    t.Literal('Leave_GEN'),
    t.Literal('LoadingCalcShifts_GEN'),
    t.Literal('Lookup_GEN'),
    t.Literal('PAYGCompany_GEN'),
    t.Literal('PAYG_GEN'),
    t.Literal('PayPeriods_GEN'),
    t.Literal('PayrollEmpl_GEN'),
    t.Literal('PayrollLeave_GEN'),
    t.Literal('PayrollPayment_GEN'),
    t.Literal('Payroll_GEN'),
    t.Literal('PayrunEmpls_GEN'),
    t.Literal('PayrunJobs_GEN'),
    t.Literal('Persons_GEN'),
    t.Literal('ReportJobs_GEN'),
    t.Literal('ReportsMenuParams_GEN'),
    t.Literal('ReportsParams_GEN'),
    t.Literal('ResetEmpl_GEN'),
    t.Literal('RosterAreas_GEN'),
    t.Literal('Shifts_GEN'),
    t.Literal('STPEvents_GEN'),
    t.Literal('SuperFund_GEN'),
    t.Literal('SuperPlans_GEN'),
    t.Literal('TCIDS_GEN'),
    t.Literal('TempSession_GEN'),
    t.Literal('TimeRange_GEN'),
    t.Literal('TimesheetShift_GEN'),
]);
exports.OzediEmplSuperRecordT = t.Object({
    Title: t.String(),
    FGiven: t.String(),
    SGiven: (0, meta_types_1.MaybeT)(t.String()),
    Surname: t.String(),
    StreetAddress: t.String(),
    City: t.String(),
    State: t.String(),
    PostCode: t.String(),
    PhoneNo: (0, meta_types_1.MaybeT)(t.String()),
    MobileNo: (0, meta_types_1.MaybeT)(t.String()),
    Email: (0, meta_types_1.MaybeT)(t.String()),
    Sex: t.String(),
    BirthDate: t.String(),
    TaxNo: t.String(),
    CommDate: t.String(),
    EndDate: (0, meta_types_1.MaybeT)(t.String()),
    OccSuper: t.Object({
        JoinDate: t.String(),
        MemberNumber: t.String(),
        SuperFundKey: t.Number(),
        Amount: t.String(),
    }),
    PersSuper: t.Record(t.Number(), t.Object({
        JoinDate: t.String(),
        MemberNumber: t.String(),
        SuperFundKey: t.Number(),
        Amount: t.String(),
    })),
});
exports.OzediSuperMemberDataT = t.Object({
    address: t.Object({
        addressDetailsUsage: t.String(),
        addressLine1: t.String(),
        addressLine2: (0, meta_types_1.MaybeT)(t.String()),
        addressLine3: (0, meta_types_1.MaybeT)(t.String()),
        addressLine4: (0, meta_types_1.MaybeT)(t.String()),
        country: t.String(),
        postCode: t.String(),
        state: t.String(),
        suburb: t.String(),
    }),
    birthDate: t.String(),
    childContributions: (0, meta_types_1.MaybeT)(t.String()),
    emailAddress: (0, meta_types_1.MaybeT)(t.String()),
    employerContributionsAwardOrProductivity: (0, meta_types_1.MaybeT)(t.String()),
    employerContributionsSalarySacrificed: (0, meta_types_1.MaybeT)(t.String()),
    employerContributionsSuperannuationGuarantee: (0, meta_types_1.MaybeT)(t.String()),
    employerContributionsVoluntary: (0, meta_types_1.MaybeT)(t.String()),
    employmentEndDate: t.String(),
    employmentEndReason: (0, meta_types_1.MaybeT)(t.String()),
    memberId: t.String(),
    name: t.Object({
        title: t.String(),
        nameSuffix: (0, meta_types_1.MaybeT)(t.String()),
        givenName: t.String(),
        otherGivenName: (0, meta_types_1.MaybeT)(t.String()),
        familyName: t.String(),
    }),
    otherThirdPartyContributions: (0, meta_types_1.MaybeT)(t.String()),
    payPeriodEnd: t.String(),
    payPeriodStart: t.String(),
    payrollNumber: t.String(),
    personalContributions: t.String(),
    phone: t.Optional(t.Object({
        phone: t.String(),
        phoneArea: (0, meta_types_1.MaybeT)(t.String()),
        phoneServiceLine: t.String(),
    })),
    sex: t.String(),
    spouseContributions: (0, meta_types_1.MaybeT)(t.String()),
    superannuationFundMember: t.String(),
    taxFileNumberNotProvided: t.String(),
});
exports.OzediSuperNewMemberDataT = t.Object({
    address: t.Object({
        addressDetailsUsage: t.String(),
        addressLine1: t.String(),
        addressLine2: (0, meta_types_1.MaybeT)(t.String()),
        addressLine3: (0, meta_types_1.MaybeT)(t.String()),
        addressLine4: (0, meta_types_1.MaybeT)(t.String()),
        country: t.String(),
        postCode: t.String(),
        state: t.String(),
        suburb: t.String(),
    }),
    annualSalaryForBenefitsAmount: (0, meta_types_1.MaybeT)(t.String()),
    annualSalaryForContributionsAmount: (0, meta_types_1.MaybeT)(t.String()),
    annualSalaryForContributionsEffectiveEndDate: (0, meta_types_1.MaybeT)(t.String()),
    annualSalaryForContributionsEffectiveStartDate: (0, meta_types_1.MaybeT)(t.String()),
    annualSalaryForInsuranceAmount: (0, meta_types_1.MaybeT)(t.String()),
    atWorkIndicator: t.String(),
    benefitCategoryText: (0, meta_types_1.MaybeT)(t.String()),
    birthDate: t.String(),
    emailAddress: (0, meta_types_1.MaybeT)(t.String()),
    employmentStartDate: t.String(),
    employmentStatusCode: (0, meta_types_1.MaybeT)(t.String()),
    fundRegistrationDate: t.String(),
    insuranceOptOutIndicator: t.String(),
    memberId: t.String(),
    memberRegistrationAmendmentReasonText: (0, meta_types_1.MaybeT)(t.String()),
    name: t.Object({
        title: t.String(),
        nameSuffix: (0, meta_types_1.MaybeT)(t.String()),
        givenName: t.String(),
        otherGivenName: (0, meta_types_1.MaybeT)(t.String()),
        familyName: t.String(),
    }),
    occupationDescription: (0, meta_types_1.MaybeT)(t.String()),
    payrollNumber: t.String(),
    phone: t.Optional(t.Object({
        phone: t.String(),
        phoneArea: (0, meta_types_1.MaybeT)(t.String()),
        phoneServiceLine: t.String(),
    })),
    sex: t.String(),
    superContributionCeaseDate: (0, meta_types_1.MaybeT)(t.String()),
    superContributionCommenceDate: t.String(),
    superannuationFundMember: t.String(),
    taxFileNumberNotProvided: t.String(),
    weeklyHoursWorkedNumber: (0, meta_types_1.MaybeT)(t.String()),
});
exports.OzediMessageResponseT = t.Object({
    accountBsb: t.Optional(t.String()),
    accountName: t.Optional(t.String()),
    accountNumber: t.Optional(t.String()),
    actionType: t.String(),
    amount: t.Optional(t.String()),
    auditCreated: t.Optional(t.String()),
    clientId: t.String(),
    conversartionId: t.String(),
    messageStatus: t.String(),
    messageUuid: t.String(),
    paymentProvider: t.Optional(t.String()),
    paymentReferenceNumber: t.Optional(t.String()),
    uploadUuid: t.String(),
    date: t.Optional(t.String()),
    isInError: t.Optional(t.Boolean()),
    maximumSeverityCode: t.Optional(t.String()),
});
exports.OzediUploadFileErrorsT = t.Object({
    conversationId: t.Optional(t.String()),
    errorCode: t.Optional(t.String()),
    errorNo: t.Optional(t.Number()),
    fundType: t.Optional(t.String()),
    id: t.Optional(t.String()),
    idType: t.Optional(t.String()),
    lineType: t.Optional(t.String()),
    longDesc: t.Optional(t.String()),
    parameters: t.Optional(t.Record(t.String(), t.String())),
    partId: t.Optional(t.String()),
    payeeAbn: t.Optional(t.String()),
    payeeUsi: t.Optional(t.String()),
    payerAbn: t.Optional(t.String()),
    payerName: t.Optional(t.String()),
    paymentDate: t.Optional(t.String()),
    severity: t.Optional(t.String()),
    shortDesc: t.Optional(t.String()),
});
exports.OzediPaymentsFileT = t.Object({
    'Payment Action': t.String(),
    'Remittance Status': t.String(),
    'Payer Name': t.String(),
    'Payment Status': t.String(),
    'Payment Reference No': t.String(),
    'Payment Bpay Biller': t.String(),
    'Payment Currency': t.String(),
    'Payment Status Date (AEST)': t.String(),
    'Remittance Status Date (AEST)': t.String(),
    'Fund Type': t.String(),
    'Payee ABN': t.String(),
    'Conversation ID': t.String(),
    'Payee USI': t.String(),
    'Payment Account No': t.String(),
    'Payment Amount': t.String(),
    'Error Description': t.String(),
    'Payer ABN': t.String(),
    'Payment Bpay Reference': t.String(),
    'Payment Account Name': t.String(),
    'Payment Date': t.String(),
    'Payment BSB': t.String(),
    'Payment Rails': t.String(),
    'Payment Method': t.String(),
    'Fund Details Expiry/Change Date': t.String(),
});
const OzediFundResponseXMLEventItemParamT = t.Object({
    'Parameter.Identifier': t.String(),
    'Parameter.Text': t.Union([t.String(), t.Number()]),
});
const OzediFundResponseXMLEventItemLocT = t.Object({
    'Location.Instance.Identifier': t.String(),
});
const OzediFundResponseXMLEventItemT = t.Object({
    'Error.Code': t.String(),
    'Severity.Code': t.String(),
    'Short.Description': t.String(),
    'Detailed.Description': t.Optional(t.String()),
    Parameters: t.Optional(t.Object({
        Parameter: t
            .Transform(t.Union([
            t.Array(OzediFundResponseXMLEventItemParamT),
            OzediFundResponseXMLEventItemParamT,
        ]))
            .Decode(v => (Array.isArray(v) ? v : [v]))
            .Encode(v => v),
    })),
    Locations: t.Optional(t.Object({
        Location: t
            .Transform(t.Union([
            t.Array(OzediFundResponseXMLEventItemLocT),
            OzediFundResponseXMLEventItemLocT,
        ]))
            .Decode(v => (Array.isArray(v) ? v : [v]))
            .Encode(v => v),
    })),
});
exports.OzediFundResponseXMLT = t.Object({
    Event: t.Object({
        'MaximumSeverity.Code': t.String(),
        EventItems: t.Object({
            EventItem: t
                .Transform(t.Union([
                t.Array(OzediFundResponseXMLEventItemT),
                OzediFundResponseXMLEventItemT,
            ]))
                .Decode(v => (Array.isArray(v) ? v : [v]))
                .Encode(v => v),
        }),
    }),
});
exports.ValidationErrorsT = t.Object({
    inactiveOccSuper: t.Array(t.Object({
        EmployeeCode: t.Number(),
        PlanKey: t.Number(),
    })),
    inactivePersSuper: t.Array(t.Object({
        EmployeeCode: t.Number(),
        PlanKey: t.Number(),
        SuperType: t.Number(),
    })),
    invalid24HrOverlaps: t.Array(t.Object({
        EmployeeCode: t.Number(),
        RunDay: t.Number(),
    })),
    invalidALAnnivDates: t.Array(t.Number()),
    invalidAPRAFunds: t.Array(t.Object({
        EmployeeCode: t.Number(),
        Type: t.String(),
        Name: t.String(),
    })),
    invalidBSOverlaps: t.Array(t.Object({
        EmployeeCode: t.Number(),
        RunDay: t.Number(),
    })),
    invalidBSShiftTypes: t.Array(t.Object({
        JobCode: t.Number(),
        RunDay: t.Number(),
        StartTime: t.String(),
    })),
    invalidClassBSGapAllow: t.Array(t.Number()),
    invalidCompanyRegos: t.Array(t.Number()),
    invalidDefaultSuperFormats: t.Array(t.Number()),
    invalidDefaultSuperFunds: t.Array(t.Number()),
    invalidDeathTerminations: t.Array(t.Number()),
    invalidDeductBanking: t.Array(t.Object({
        EmployeeCode: t.Number(),
        DeductType: t.Number(),
    })),
    invalidEmplABNs: t.Array(t.Number()),
    invalidEmplComp: t.Array(t.Number()),
    invalidEmplTaxOptions: t.Array(t.Number()),
    invalidEmplTerminations: t.Array(t.Number()),
    invalidGaps: t.Array(t.Object({
        ID: t.String(),
        EmployeeCode: t.Number(),
        RunDay: t.Number(),
    })),
    invalidJKAllowances: t.Array(t.Number()),
    invalidJobSplits: t.Array(t.Number()),
    invalidJobTerminations: t.Array(t.Number()),
    invalidLSL: t.Array(t.Number()),
    invalidMaxOccSuperCont: t.String(),
    invalidOccSuper: t.Array(t.Number()),
    invalidPayrollRecords: t.Array(t.Object({
        EmployeeCode: t.Number(),
        JobCode: t.Number(),
    })),
    invalidPersSuper: t.Array(t.Number()),
    invalidSMSFs: t.Array(t.Object({
        ID: t.Number(),
        Name: t.String(),
        EndDate: t.String(),
    })),
    invalidStaticAvg: t.Array(t.Number()),
    invalidTaxRefund: t.Array(t.Object({
        EmployeeCode: t.Number(),
        RefundedTax: t.Number(),
        TotalTax: t.Number(),
    })),
    missingAddSeq: t.Array(t.Number()),
    missingBaseShift: t.Array(t.Number()),
    missingBankInfo: t.Array(t.Number()),
    missingBSGapAllow: t.Array(t.Number()),
    missingCHRego: t.Array(t.Number()),
    missingDefaultJob: t.Array(t.Number()),
    missingDefaultSuperFund: t.String(),
    missingHolRates: t.Array(t.Number()),
    missingLeaveAnnivDates: t.Array(t.Number()),
    missingLumpDRates: t.String(),
    missingLSLCurrent: t.Array(t.Number()),
    missingLSLSeq: t.Array(t.Number()),
    missingPayToAgreements: t.Array(t.Number()),
    missingRateSeq: t.Array(t.Number()),
    missingRateSeq2: t.Array(t.Number()),
    missingRosterAreas: t.Array(t.Number()),
    missingSLSeq: t.Array(t.Number()),
    missingSTPApproval: t.Array(t.Number()),
    missingSuperFund: t.Array(t.Number()),
    missingSuperUSI: t.Array(t.Number()),
    underSuperMinAge: t.Array(t.Number()),
    underSuperMinAgeOverHours: t.Array(t.Number()),
    unpaidPrepayments: t.Array(t.Object({
        EmployeeCode: t.Number(),
        PayrollEmplKey: t.Number(),
    })),
    tpeErrorData: t.Array(t.Object({})),
});
exports.ValidationWarningsT = t.Object({
    BSOverlaps: t.Array(t.Object({
        EmployeeCode: t.Number(),
        RunDay: t.Number(),
        PayrunJobKey: t.Number(),
    })),
    expiringAPRAFunds: t.Array(t.Object({
        EmployeeCode: t.Number(),
        Type: t.String(),
        Name: t.String(),
        EndDate: t.String(),
    })),
    expiringSMSFs: t.Array(t.Object({
        ID: t.Number(),
        Name: t.String(),
        EndDate: t.String(),
    })),
    invalidContributionStatus: t.Array(t.Number()),
    lowRates: t.Array(t.Object({
        JobCode: t.Number(),
        AwardRate: t.Number(),
        SpecBaseRate: t.Number(),
    })),
    missingBankInfo: t.Array(t.Number()),
    missingEmpls: t.Array(t.Number()),
    missingSuperFund: t.Array(t.Number()),
    missingSuperUSI: t.Array(t.Number()),
    paydaySuperAmountWarnings: t.Record(t.String(), t.Object({
        ABN: t.String(),
        SuperFundKey: t.Number(),
        PlanKey: t.Number(),
        TotalAmount: t.Number(),
    })),
    pubHols: t.Array(t.Number()),
    underSuperMinAge: t.Array(t.Number()),
    underSuperMinAgeOverHours: t.Array(t.Number()),
    unprocessedOccSuper: t.Array(exports.OccSuperUnprocessedT),
});
//# sourceMappingURL=types-payroll.js.map